/**
 * Passe-partout Builder — Atelier Toon
 * Vanilla JS, geen frameworks
 */

(function () {
  'use strict';

  // ----------------------------------------------------------------
  // Config
  // ----------------------------------------------------------------

  const FORMATS = [
    { key: '21x30', label: 'A4 / 21×29,7 cm', w: 21, h: 29.7 },
    { key: '30x40', label: '30×40 cm', w: 30, h: 40 },
    { key: '40x50', label: '40×50 cm', w: 40, h: 50 },
    { key: '50x70', label: '50×70 cm', w: 50, h: 70 },
  ];

  const PRICES = {
    'small': { standaard: 20.95, linnenstof: 22.95 }, // onder 15×15 cm
    '21x30': { standaard: 25.95, linnenstof: 27.95 },
    '30x40': { standaard: 33.95, linnenstof: 35.95 },
    '40x50': { standaard: 43.95, linnenstof: 45.95 },
    '50x70': { standaard: 53.95, linnenstof: 55.95 },
  };

  const COLORS = [
    { name: 'Breezy Blue',       hex: '#C3DBF4', light: true  },
    { name: 'Hold My Olive - Green', hex: '#9E9440', light: false },
    { name: 'Sage Green',        hex: '#B8D8B1', light: true  },
    { name: 'White Like A Wave', hex: '#F4F4F1', light: true  },
    { name: 'Bravo Blue',        hex: '#2E5491', light: false },
    { name: 'Canvas Cream',      hex: '#f5f2ea', light: true  },
    { name: 'Linnen 1',          hex: '#cfcec4', light: true,  texture: 'linen' },
    { name: 'Rioja Red - Bordeaux', hex: '#6E1A26', light: false },
    { name: 'Bold & Brown',      hex: '#5B2B1E', light: false },
    { name: 'Linnen 2',          hex: '#e8e0c7', light: true,  texture: 'linen' },
    { name: 'Butter Yellow',     hex: '#faefc2', light: true,  surcharge: 2 },
    { name: 'Cherry Cola - Red', hex: '#C41E2A', light: false },
  ];

  // ----------------------------------------------------------------
  // i18n — locale-aware strings
  // ----------------------------------------------------------------

  const LANG = (window.ppbLocale || 'nl').slice(0, 2);
  const isEN = LANG === 'en';
  const isDE = LANG === 'de';
  function tri(en, nl, de) { return isDE ? de : (isEN ? en : nl); }

  const T = {
    // Validation errors
    widthBetween:    tri('Width must be between 10 and 50 cm', 'Breedte moet tussen 10 en 50 cm zijn', 'Die Breite muss zwischen 10 und 50 cm liegen'),
    heightBetween:   tri('Height must be between 10 and 70 cm', 'Hoogte moet tussen 10 en 70 cm zijn', 'Die Höhe muss zwischen 10 und 70 cm liegen'),
    enterValidSize:  tri('enter a valid inner size', 'voer een geldige binnenmaat in', 'gib ein gültiges Innenmaß ein'),
    widthMin:        tri('width minimum {n} cm', 'breedte minimaal {n} cm', 'Breite mindestens {n} cm'),
    heightMin:       tri('height minimum {n} cm', 'hoogte minimaal {n} cm', 'Höhe mindestens {n} cm'),
    widthMax:        tri('width too large (max {n} cm)', 'breedte te groot (max {n} cm)', 'Breite zu groß (max. {n} cm)'),
    heightMax:       tri('height too large (max {n} cm)', 'hoogte te groot (max {n} cm)', 'Höhe zu groß (max. {n} cm)'),
    tooCloseBorder:  tri('Opening {n}: too close to the outer edge (min. {m} cm)', 'Opening {n}: te dicht bij de buitenrand (min. {m} cm)', 'Öffnung {n}: zu nah am Außenrand (mind. {m} cm)'),
    wouldOverlap:    tri('Opening {a} and {b} would overlap', 'Opening {a} en {b} zouden overlappen', 'Öffnung {a} und {b} würden sich überlappen'),
    tooClose:        tri('Opening {a} and {b} are too close together (min. 1 cm gap)', 'Opening {a} en {b} zitten te dicht bij elkaar (min. 1 cm tussenruimte)', 'Öffnung {a} und {b} liegen zu nah beieinander (mind. 1 cm Abstand)'),
    // Summary table
    labelFormat:     tri('Size', 'Formaat', 'Größe'),
    labelMaterial:   tri('Material', 'Materiaal', 'Material'),
    labelColour:     tri('Colour', 'Kleur', 'Farbe'),
    labelOpenings:   tri('Openings', 'Openingen', 'Öffnungen'),
    labelInnerSize:  tri('Inner size', 'Binnenmaat', 'Innenmaß'),
    labelOpening:    tri('Opening', 'Opening', 'Öffnung'),
    labelRotation:   tri('Rotation', 'Rotatie', 'Drehung'),
    // Materials
    matLinen:        tri('Linen', 'Linnenstof', 'Leinen'),
    matStandard:     tri('Standard', 'Standaard', 'Standard'),
    // Per-opening inputs
    labelWidth:      tri('Width', 'Breedte', 'Breite'),
    labelHeight:     tri('Height', 'Hoogte', 'Höhe'),
    labelLeft:       tri('Left', 'Links', 'Links'),
    labelRight:      tri('Right', 'Rechts', 'Rechts'),
    labelTop:        tri('Top', 'Boven', 'Oben'),
    labelBottom:     tri('Bottom', 'Onder', 'Unten'),
    labelSelect:     tri('Select', 'Selecteer', 'Auswählen'),
    labelRotate:     tri('Rotation:', 'Rotatie:', 'Drehung:'),
    labelCentre:     tri('Centre:', 'Centreren:', 'Zentrieren:'),
    cheatsheetBtn:   tri('View standard sizes', 'Bekijk standaard maten', 'Standardgrößen ansehen'),
    // Photo upload
    photoLoaded:     tri('Photo loaded', 'Foto geladen', 'Foto geladen'),
    photoRemove:     tri('Remove photo', 'Foto verwijderen', 'Foto entfernen'),
    photoUpload:     tri('Upload photo (optional)', 'Foto uploaden (optioneel)', 'Foto hochladen (optional)'),
    // Cart
    adding:          tri('Adding…', 'Toevoegen…', 'Wird hinzugefügt…'),
    addToCart:       tri('Add to cart', 'Toevoegen aan winkelwagen', 'In den Warenkorb'),
    addedToCart:     tri('Added to cart!', 'Toegevoegd aan winkelwagen!', 'Zum Warenkorb hinzugefügt!'),
    productNotFound: tri('Product not found. Please contact hello@ateliertoon.com', 'Product niet gevonden. Neem contact op via hello@ateliertoon.com', 'Produkt nicht gefunden. Bitte melde dich unter hello@ateliertoon.com'),
    addError:        tri('Error adding to cart: ', 'Fout bij toevoegen: ', 'Fehler beim Hinzufügen: '),
    // Align errors
    alignFailed:     tri('Alignment not possible: ', 'Uitlijnen niet mogelijk: ', 'Ausrichten nicht möglich: '),
    centreFailed:    tri('Centering not possible: ', 'Centreren niet mogelijk: ', 'Zentrieren nicht möglich: '),
    // Price label
    basedOn:         tri(' (based on {label})', ' (o.b.v. {label})', ' (auf Basis von {label})'),
    // SVG aria
    svgAria:         tri('Preview passe-partout {label}, {mat}, colour {col}', 'Preview passe-partout {label}, {mat}, kleur {col}', 'Vorschau Passepartout {label}, {mat}, Farbe {col}'),
    // Overlap warning (dynamic text built in JS)
    openingPrefix:   tri('Opening ', 'Opening ', 'Öffnung '),
    // Cart property labels (visible in cart/order)
    cartFormat:       tri('Size', 'Formaat', 'Größe'),
    cartMaterial:     tri('Material', 'Materiaal', 'Material'),
    cartMatStandard:  tri('Standard', 'Standaard', 'Standard'),
    cartMatLinen:     tri('Linen', 'Linnenstof', 'Leinen'),
    cartColour:       tri('Colour', 'Kleur', 'Farbe'),
    cartOpenings:     tri('Openings', 'Aantal openingen', 'Anzahl Öffnungen'),
    cartInnerSize:    tri('Inner size', 'Binnenmaat', 'Innenmaß'),
    cartMarginLeft:   tri('Left margin', 'Marge Links', 'Rand links'),
    cartMarginRight:  tri('Right margin', 'Marge Rechts', 'Rand rechts'),
    cartMarginTop:    tri('Top margin', 'Marge Boven', 'Rand oben'),
    cartMarginBottom: tri('Bottom margin', 'Marge Onder', 'Rand unten'),
    cartPreview:      tri('_Preview', '_Voorbeeld', '_Preview'), // DE bewust _Preview: winkelwagen en orderbevestiging kennen alleen deze twee
    // Bewerken vanuit winkelwagen
    editNotice:      tri('You are editing an item in your cart.', 'Je bewerkt een item in je winkelwagen.', 'Du bearbeitest einen Artikel in deinem Warenkorb.'),
    editCancel:      tri('Cancel', 'Annuleren', 'Abbrechen'),
    saveChanges:     tri('Save changes', 'Wijzigingen opslaan', 'Änderungen speichern'),
    saving:          tri('Saving\u2026', 'Opslaan\u2026', 'Wird gespeichert\u2026'),
    savedChanges:    tri('Changes saved!', 'Wijzigingen opgeslagen!', 'Änderungen gespeichert!'),
    saveError:       tri('Error saving: ', 'Fout bij opslaan: ', 'Fehler beim Speichern: '),
    editNotFound:    tri('This item is no longer in your cart. Your design has been loaded as a new one.', 'Dit item staat niet meer in je winkelwagen. Je ontwerp is als nieuw ontwerp geladen.', 'Dieser Artikel ist nicht mehr in deinem Warenkorb. Dein Entwurf wurde als neuer Entwurf geladen.'),
  };

  const MIN_MARGIN   = 2; // cm vrije ruimte tussen opening en buitenrand
  const MIN_GAP      = 1; // cm minimale tussenruimte (validatie)
  const LAYOUT_GAP   = 3; // cm tussenruimte bij initiële plaatsing
  const MIN_OPENING  = 3; // cm minimale breedte én hoogte van een opening

  // ----------------------------------------------------------------
  // State
  // ----------------------------------------------------------------

  let svgDrag   = null; // actieve drag/resize operatie op de SVG preview
  let snapLines = []; // { axis: 'v'|'h', pos: cm, center: bool } tijdens verslepen
  let copiedOpenings = []; // klembord voor ⌘C / ⌘V

  const state = {
    // Stap 1 — Formaat
    format: '21x30',
    customFormat: false,
    customW: 21,
    customH: 30,

    // Stap 2 — Kleur + Materiaal
    material: 'standaard',
    color: 'Canvas Cream',

    // Stap 3 — Binnenmaat (template / startwaarde voor nieuwe openingen)
    openingW: 7,
    openingH: 10,

    // Stap 4 — Openingen: elke opening heeft eigen afmeting, positie en foto
    openings: 1,
    openingPositions: Array.from({ length: 20 }, function () {
      return { left: null, top: null, w: 7, h: 10, rotation: 0, photoDataUrl: null, photoW: null, photoH: null };
    }),

    // Uitlijning — geselecteerde openingen (indices)
    selectedOpenings: new Set(),
  };

  // ----------------------------------------------------------------
  // Undo
  // ----------------------------------------------------------------

  const MAX_HISTORY = 30;
  const history = [];

  function saveHistory() {
    history.push({
      openings: state.openings,
      openingPositions: state.openingPositions.map(function (p) { return Object.assign({}, p); }),
      selectedOpenings: new Set(state.selectedOpenings),
    });
    if (history.length > MAX_HISTORY) history.shift();
    const btn = document.getElementById('ppb-undo');
    if (btn) btn.disabled = false;
  }

  function undoHistory() {
    if (!history.length) return;
    const snap = history.pop();
    state.openings = snap.openings;
    state.openingPositions = snap.openingPositions;
    state.selectedOpenings = snap.selectedOpenings; // selectie behouden
    const btn = document.getElementById('ppb-undo');
    if (btn) btn.disabled = history.length === 0;
    // Sync knoppen
    document.querySelectorAll('.ppb-opening-btn').forEach(function (b) {
      b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false');
    });
    const fixedBtn = document.getElementById('ppb-openings-' + state.openings);
    if (fixedBtn) { fixedBtn.classList.add('is-active'); fixedBtn.setAttribute('aria-pressed', 'true'); }
    const customInput = document.getElementById('ppb-openings-custom');
    if (customInput) customInput.value = [1,2,3,4].includes(state.openings) ? '' : state.openings;
    renderPositionInputs();
    update();
  }

  // ----------------------------------------------------------------
  // Helpers
  // ----------------------------------------------------------------

  // Prijs zoals de bezoeker hem afrekent. In een markt met een eigen munt
  // (Zweden, Denemarken, Polen, ...) rekent Shopify de variantprijs om en rondt
  // die af op hele eenheden; die omgerekende prijs is dan de waarheid en niet
  // onze eigen som in euro's.
  function formatPrice(amount) {
    const currency = (window.Shopify && window.Shopify.currency &&
                      window.Shopify.currency.active) || 'EUR';

    if (currency !== 'EUR') {
      const variant = findVariant();
      if (variant) {
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency,
          }).format(parseInt(variant.price, 10) / 100);
        } catch (e) { /* onbekende valuta -- val terug op euro's */ }
      }
    }

    return '€\u00a0' + amount.toFixed(2).replace('.', ',');
  }

  function getActiveFormat() {
    if (state.customFormat) {
      return {
        key: 'custom',
        label: state.customW + '\u00d7' + state.customH + ' cm',
        w: state.customW,
        h: state.customH,
      };
    }
    return FORMATS.find(f => f.key === state.format);
  }

  function getActiveColor() {
    return COLORS.find(c => c.name === state.color);
  }

  function getCustomFormatBaseKey() {
    const shorter = Math.min(state.customW, state.customH);
    const longer  = Math.max(state.customW, state.customH);
    if (shorter < 20 && longer < 25)           return 'small';  // onder 20×25 cm
    if (shorter <= 21 && longer <= 30)         return '21x30';  // t/m 21×30
    if (shorter <= 32 && longer <= 42)         return '30x40';  // t/m 32×42
    if (shorter <= 42 && longer <= 52)         return '40x50';  // t/m 42×52
    return '50x70';                                             // t/m 50×70
  }

  function getPrice() {
    const key = state.customFormat ? getCustomFormatBaseKey() : state.format;
    const base = PRICES[key][state.material];
    const color = COLORS.find(function (c) { return c.name === state.color; });
    const surcharge = (color && color.surcharge) ? color.surcharge : 0;
    return base + surcharge;
  }

  // ----------------------------------------------------------------
  // Validatie
  // ----------------------------------------------------------------

  function validateFormat() {
    if (!state.customFormat) return [];
    const errors = [];
    if (state.customW < 10 || state.customW > 50)
      errors.push(T.widthBetween);
    if (state.customH < 10 || state.customH > 70)
      errors.push(T.heightBetween);
    return errors;
  }

  function validateOpeningSize() {
    const fmt = getActiveFormat();
    const maxW = fmt.w - 2 * MIN_MARGIN;
    const maxH = fmt.h - 2 * MIN_MARGIN;
    const errors = [];
    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const prefix = state.openings > 1 ? 'Opening ' + (i + 1) + ': ' : '';
      if (od.w <= 0 || od.h <= 0)
        errors.push(prefix + T.enterValidSize);
      else if (od.w < MIN_OPENING)
        errors.push(prefix + T.widthMin.replace('{n}', MIN_OPENING));
      else if (od.h < MIN_OPENING)
        errors.push(prefix + T.heightMin.replace('{n}', MIN_OPENING));
      else if (od.w > maxW)
        errors.push(prefix + T.widthMax.replace('{n}', maxW.toFixed(1)));
      else if (od.h > maxH)
        errors.push(prefix + T.heightMax.replace('{n}', maxH.toFixed(1)));
    }
    return errors;
  }

  var FLOAT_EPSILON = 0.05; // tolerantie voor afrondingsfouten bij exact MIN_GAP

  function rectsTooClose(a, b) {
    return !(a.x + a.w + MIN_GAP - FLOAT_EPSILON <= b.x || b.x + b.w + MIN_GAP - FLOAT_EPSILON <= a.x ||
             a.y + a.h + MIN_GAP - FLOAT_EPSILON <= b.y || b.y + b.h + MIN_GAP - FLOAT_EPSILON <= a.y);
  }

  function rectsOverlap(a, b) {
    return !(a.x + a.w <= b.x || b.x + b.w <= a.x ||
             a.y + a.h <= b.y || b.y + b.h <= a.y);
  }

  function validatePositions() {
    const fmt = getActiveFormat();
    const errors = [];
    const rects = [];

    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const left = od.left !== null ? od.left : (fmt.w - od.w) / 2;
      const top  = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;

      if (left < MIN_MARGIN || left + od.w > fmt.w - MIN_MARGIN)
        errors.push(T.tooCloseBorder.replace('{n}', i + 1).replace('{m}', MIN_MARGIN));
      if (top < MIN_MARGIN || top + od.h > fmt.h - MIN_MARGIN)
        errors.push(T.tooCloseBorder.replace('{n}', i + 1).replace('{m}', MIN_MARGIN));

      rects.push({ x: left, y: top, w: od.w, h: od.h });
    }

    for (let i = 0; i < rects.length; i++) {
      for (let j = i + 1; j < rects.length; j++) {
        if (rectsTooClose(rects[i], rects[j])) {
          const msg = rectsOverlap(rects[i], rects[j])
            ? T.wouldOverlap.replace('{a}', i + 1).replace('{b}', j + 1)
            : T.tooClose.replace('{a}', i + 1).replace('{b}', j + 1);
          errors.push(msg);
        }
      }
    }

    return errors;
  }

  function validateAll() {
    return [...validateFormat(), ...validateOpeningSize(), ...validatePositions()];
  }

  // ----------------------------------------------------------------
  // Uitlijning van geselecteerde openingen
  // ----------------------------------------------------------------

  function alignOpenings(direction) {
    const indices = Array.from(state.selectedOpenings);
    if (indices.length < 2) return;
    if (['left', 'right', 'top', 'bottom'].indexOf(direction) === -1) return;
    saveHistory();

    // Sla huidige posities op zodat we kunnen terugdraaien bij validatiefout
    const snapshots = indices.map(function (i) {
      return { i: i, left: state.openingPositions[i].left, top: state.openingPositions[i].top };
    });

    if (direction === 'left') {
      const avg = parseFloat((indices.reduce(function (sum, i) { return sum + getEffectiveLeft(i); }, 0) / indices.length).toFixed(2));
      indices.forEach(function (i) { state.openingPositions[i].left = avg; });

    } else if (direction === 'right') {
      const avg = parseFloat((indices.reduce(function (sum, i) {
        return sum + getEffectiveLeft(i) + state.openingPositions[i].w;
      }, 0) / indices.length).toFixed(2));
      indices.forEach(function (i) {
        state.openingPositions[i].left = parseFloat((avg - state.openingPositions[i].w).toFixed(2));
      });

    } else if (direction === 'top') {
      const avg = parseFloat((indices.reduce(function (sum, i) { return sum + getEffectiveTop(i); }, 0) / indices.length).toFixed(2));
      indices.forEach(function (i) { state.openingPositions[i].top = avg; });

    } else if (direction === 'bottom') {
      const avg = parseFloat((indices.reduce(function (sum, i) {
        return sum + getEffectiveTop(i) + state.openingPositions[i].h;
      }, 0) / indices.length).toFixed(2));
      indices.forEach(function (i) {
        state.openingPositions[i].top = parseFloat((avg - state.openingPositions[i].h).toFixed(2));
      });
    }

    // Valideer resultaat; draai terug bij fout
    var errors = validatePositions();
    if (errors.length > 0) {
      snapshots.forEach(function (s) {
        state.openingPositions[s.i].left = s.left;
        state.openingPositions[s.i].top  = s.top;
      });
      var alignErr = document.getElementById('ppb-align-error');
      if (alignErr) {
        alignErr.textContent = T.alignFailed + errors[0].toLowerCase();
        alignErr.style.display = '';
        clearTimeout(alignErr._timer);
        alignErr._timer = setTimeout(function () {
          alignErr.style.display = 'none';
          alignErr.textContent = '';
        }, 5000);
      }
      return;
    }

    var alignErr = document.getElementById('ppb-align-error');
    if (alignErr) { alignErr.style.display = 'none'; alignErr.textContent = ''; }

    renderPositionInputs();
    update();
  }

  // ----------------------------------------------------------------
  // SVG Preview
  // ----------------------------------------------------------------

  function getOpeningRects(fmt, scale) {
    return Array.from({ length: state.openings }, (_, i) => {
      const od = state.openingPositions[i];
      const left = od.left !== null ? od.left : (fmt.w - od.w) / 2;
      const top  = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;
      return {
        x: left * scale,
        y: top  * scale,
        w: od.w  * scale,
        h: od.h  * scale,
        rot: od.rotation || 0,
        photoDataUrl: od.photoDataUrl,
        photoW:       od.photoW,
        photoH:       od.photoH,
      };
    });
  }

  function getTexturePattern(color, material, patternId) {
    const hex = color.hex;
    const isLinen = color.texture === 'linen' || material === 'linnenstof';
    if (isLinen) {
      // Realistisch geweven linnen-patroon: ketting (horizontaal) en inslag (verticaal)
      return '<pattern id="' + patternId + '" patternUnits="userSpaceOnUse" width="8" height="8">' +
        '<rect width="8" height="8" fill="' + hex + '"/>' +
        // Horizontale kettingdraden
        '<rect x="0" y="0" width="8" height="1.2" fill="rgba(255,255,255,0.13)"/>' +
        '<rect x="0" y="2" width="8" height="1.0" fill="rgba(0,0,0,0.07)"/>' +
        '<rect x="0" y="4" width="8" height="1.2" fill="rgba(255,255,255,0.10)"/>' +
        '<rect x="0" y="6" width="8" height="1.0" fill="rgba(0,0,0,0.06)"/>' +
        // Verticale inslagdraden
        '<rect x="0" y="0" width="1.2" height="8" fill="rgba(0,0,0,0.06)"/>' +
        '<rect x="2" y="0" width="1.0" height="8" fill="rgba(255,255,255,0.10)"/>' +
        '<rect x="4" y="0" width="1.2" height="8" fill="rgba(0,0,0,0.05)"/>' +
        '<rect x="6" y="0" width="1.0" height="8" fill="rgba(255,255,255,0.09)"/>' +
        // Kruispunt-highlights: afwisselend donker/licht voor weefsellook
        '<rect x="0" y="0" width="1.2" height="1.2" fill="rgba(0,0,0,0.09)"/>' +
        '<rect x="2" y="2" width="1.0" height="1.0" fill="rgba(0,0,0,0.08)"/>' +
        '<rect x="4" y="4" width="1.2" height="1.2" fill="rgba(0,0,0,0.09)"/>' +
        '<rect x="6" y="6" width="1.0" height="1.0" fill="rgba(0,0,0,0.08)"/>' +
        '<rect x="4" y="0" width="1.2" height="1.2" fill="rgba(255,255,255,0.14)"/>' +
        '<rect x="0" y="4" width="1.2" height="1.2" fill="rgba(255,255,255,0.12)"/>' +
        '<rect x="6" y="2" width="1.0" height="1.0" fill="rgba(255,255,255,0.11)"/>' +
        '<rect x="2" y="6" width="1.0" height="1.0" fill="rgba(255,255,255,0.11)"/>' +
        '</pattern>';
    } else {
      return '<pattern id="' + patternId + '" patternUnits="userSpaceOnUse" width="5" height="5">' +
        '<rect width="5" height="5" fill="' + hex + '"/>' +
        '<circle cx="1" cy="1.5" r="0.4" fill="rgba(0,0,0,0.04)"/>' +
        '<circle cx="3.5" cy="3.5" r="0.3" fill="rgba(0,0,0,0.03)"/>' +
        '<circle cx="2" cy="4" r="0.35" fill="rgba(255,255,255,0.06)"/>' +
        '<circle cx="4" cy="1" r="0.3" fill="rgba(255,255,255,0.05)"/>' +
        '</pattern>';
    }
  }

  function renderSVG() {
    const fmt = getActiveFormat();
    const color = getActiveColor();

    const maxW = 340;
    const maxH = 420;
    const scale = Math.min(maxW / fmt.w, maxH / fmt.h);

    const svgW = Math.round(fmt.w * scale);
    const svgH = Math.round(fmt.h * scale);

    const sizeErrors = [...validateFormat(), ...validateOpeningSize()];
    const hasSizeErrors = sizeErrors.length > 0;
    const openingRects = hasSizeErrors ? [] : getOpeningRects(fmt, scale);

    // Bepaal welke openingen te dicht bij elkaar staan (in pixel-coördinaten)
    const minGapPx = (MIN_GAP - FLOAT_EPSILON) * scale;
    const overlappingIndices = new Set();
    for (let i = 0; i < openingRects.length; i++) {
      for (let j = i + 1; j < openingRects.length; j++) {
        const a = openingRects[i], b = openingRects[j];
        if (!(a.x + a.w + minGapPx <= b.x || b.x + b.w + minGapPx <= a.x ||
              a.y + a.h + minGapPx <= b.y || b.y + b.h + minGapPx <= a.y)) {
          overlappingIndices.add(i);
          overlappingIndices.add(j);
        }
      }
    }

    const bgColor = '#d8d4cf';
    const patternId = 'ppb-tex';

    const texturePattern = getTexturePattern(color, state.material, patternId);

    const shadowFilter =
      '<filter id="ppb-shadow" x="-8%" y="-8%" width="116%" height="116%">' +
      '<feDropShadow dx="0" dy="3" stdDeviation="5" flood-color="rgba(0,0,0,0.18)"/>' +
      '</filter>';

    // Masker: wit = passe-partout zichtbaar, zwart = opening (transparant)
    const maskRects = openingRects.map(r => {
      const cx = (r.x + r.w / 2).toFixed(1), cy = (r.y + r.h / 2).toFixed(1);
      const rect = '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
        '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '" fill="black"/>';
      return r.rot ? '<g transform="rotate(' + r.rot + ',' + cx + ',' + cy + ')">' + rect + '</g>' : rect;
    }).join('');

    const ppMask =
      '<mask id="ppb-pp-mask">' +
        '<rect width="' + svgW + '" height="' + svgH + '" fill="white"/>' +
        maskRects +
      '</mask>';

    // ClipPaths per opening (voor foto)
    const clipPaths = openingRects.map((r, i) => {
      const cx = (r.x + r.w / 2).toFixed(1), cy = (r.y + r.h / 2).toFixed(1);
      const rect = '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
        '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
        (r.rot ? ' transform="rotate(' + r.rot + ',' + cx + ',' + cy + ')"' : '') + '/>';
      return '<clipPath id="ppb-clip-' + i + '">' + rect + '</clipPath>';
    }).join('');

    const parts = [];

    // Achtergrond (gesimuleerde muur)
    parts.push('<rect width="' + svgW + '" height="' + svgH + '" fill="' + bgColor + '"/>');

    // Elke opening: eigen foto of lege achtergrond
    openingRects.forEach(function (r, i) {
      const rcx = (r.x + r.w / 2).toFixed(1), rcy = (r.y + r.h / 2).toFixed(1);
      const rotAttr = r.rot ? ' transform="rotate(' + r.rot + ',' + rcx + ',' + rcy + ')"' : '';
      if (r.photoDataUrl) {
        var photoX, photoY, photoW, photoH;
        if (r.photoW && r.photoH) {
          photoW = r.photoW * scale;
          photoH = r.photoH * scale;
          photoX = r.x + (r.w - photoW) / 2;
          photoY = r.y + (r.h - photoH) / 2;
        } else {
          photoW = r.w;
          photoH = r.h;
          photoX = r.x;
          photoY = r.y;
        }
        parts.push(
          '<image href="' + r.photoDataUrl + '"' +
          ' x="' + photoX.toFixed(1) + '" y="' + photoY.toFixed(1) + '"' +
          ' width="' + photoW.toFixed(1) + '" height="' + photoH.toFixed(1) + '"' +
          rotAttr +
          ' clip-path="url(#ppb-clip-' + i + ')"' +
          ' preserveAspectRatio="xMidYMid meet"/>'
        );
      } else {
        parts.push(
          '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
          '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
          rotAttr + ' fill="' + bgColor + '"/>'
        );
        parts.push(
          '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
          '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
          rotAttr + ' fill="none" stroke="rgba(0,0,0,0.12)" stroke-width="1.5"/>'
        );
      }
      // Rode overlay voor overlappende openingen (onder de PP-laag)
      if (overlappingIndices.has(i)) {
        parts.push(
          '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
          '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
          rotAttr + ' fill="rgba(220,50,50,0.35)"/>'
        );
      }
    });

    // Passe-partout met textuurpatroon en masker voor de openingen
    parts.push(
      '<rect width="' + svgW + '" height="' + svgH + '"' +
      ' fill="url(#' + patternId + ')"' +
      ' mask="url(#ppb-pp-mask)"' +
      ' filter="url(#ppb-shadow)"/>'
    );

    // Subtiele bevel voor lichte kleuren
    if (color.light) {
      parts.push(
        '<rect width="' + svgW + '" height="' + svgH + '"' +
        ' fill="none" stroke="rgba(0,0,0,0.08)" stroke-width="1"' +
        ' mask="url(#ppb-pp-mask)"/>'
      );
    }

    // Rode rand bovenop PP-laag voor overlappende openingen
    openingRects.forEach(function (r, i) {
      if (overlappingIndices.has(i)) {
        const rcx = (r.x + r.w / 2).toFixed(1), rcy = (r.y + r.h / 2).toFixed(1);
        const rotAttr = r.rot ? ' transform="rotate(' + r.rot + ',' + rcx + ',' + rcy + ')"' : '';
        parts.push(
          '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
          '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
          rotAttr + ' fill="none" stroke="rgba(200,0,0,0.9)" stroke-width="2.5"' +
          ' style="pointer-events:none"/>'
        );
      }
    });

    // Openingsnummer per opening
    openingRects.forEach(function (r, i) {
      var cx = (r.x + r.w / 2).toFixed(1);
      var cy = (r.y + r.h / 2).toFixed(1);
      var fs = (Math.max(14, Math.min(r.w, r.h) * 0.38) * 3).toFixed(0);
      parts.push(
        '<text x="' + cx + '" y="' + cy + '"' +
        ' text-anchor="middle" dominant-baseline="central" dy="0.1em"' +
        ' font-size="' + fs + '" font-weight="400" font-family="LittleKidsHandwriting, cursive"' +
        ' fill="rgba(0,0,0,0.20)"' +
        ' clip-path="url(#ppb-clip-' + i + ')"' +
        ' style="pointer-events:none;user-select:none">' +
        (i + 1) + '</text>'
      );
    });

    // Selectie-highlight: stippellijn langs de volledige binnenrand
    openingRects.forEach(function (r, i) {
      if (!state.selectedOpenings.has(i)) return;
      const sw = 4;
      const ins = sw / 2;
      const rx = (r.x + ins).toFixed(1), ry = (r.y + ins).toFixed(1);
      const rw = (r.w - sw).toFixed(1), rh = (r.h - sw).toFixed(1);
      const rcx = (r.x + r.w / 2).toFixed(1), rcy = (r.y + r.h / 2).toFixed(1);
      const rotAttr = r.rot ? ' transform="rotate(' + r.rot + ',' + rcx + ',' + rcy + ')"' : '';
      const clip = 'clip-path="url(#ppb-clip-' + i + ')" style="pointer-events:none"';
      // Witte achtergrondslag voor contrast op elke PP-kleur
      parts.push(
        '<rect x="' + rx + '" y="' + ry + '" width="' + rw + '" height="' + rh + '"' +
        rotAttr + ' fill="none" stroke="white" stroke-width="' + (sw + 3) + '"' +
        ' stroke-dasharray="10 6" ' + clip + '/>'
      );
      // Oranje stippellijn
      parts.push(
        '<rect x="' + rx + '" y="' + ry + '" width="' + rw + '" height="' + rh + '"' +
        rotAttr + ' fill="none" stroke="#e67000" stroke-width="' + sw + '"' +
        ' stroke-dasharray="10 6" ' + clip + '/>'
      );
    });

    // Hulplijnen tijdens verslepen: doorgetrokken voor het kadermidden,
    // gestippeld voor uitlijning op een andere opening
    snapLines.forEach(function (line) {
      const p = (line.pos * scale).toFixed(1);
      const style = ' stroke="#e33" stroke-width="1"' + (line.center ? '' : ' stroke-dasharray="4 3"') +
        ' style="pointer-events:none"/>';
      if (line.axis === 'v') {
        parts.push('<line x1="' + p + '" y1="0" x2="' + p + '" y2="' + svgH + '"' + style);
      } else {
        parts.push('<line x1="0" y1="' + p + '" x2="' + svgW + '" y2="' + p + '"' + style);
      }
    });

    return '<svg' +
      ' viewBox="0 0 ' + svgW + ' ' + svgH + '"' +
      ' width="' + svgW + '" height="' + svgH + '"' +
      ' xmlns="http://www.w3.org/2000/svg"' +
      ' role="img"' +
      ' aria-label="' + T.svgAria.replace('{label}', fmt.label).replace('{mat}', state.material).replace('{col}', color.name) + '"' +
      '><defs>' + shadowFilter + texturePattern + ppMask + clipPaths + '</defs>' +
      parts.join('') +
      '</svg>';
  }

  // ----------------------------------------------------------------
  // Openings info
  // ----------------------------------------------------------------

  function updateOpeningInfo() {
    const el = document.getElementById('ppb-opening-info');
    if (!el) return;

    const fmt = getActiveFormat();

    // Bij een maatfout klopt het overzicht niet meer en tonen we de fout.
    // Een positiefout (overlap, te dicht bij de rand) staat al rood in het
    // werkveld; de tabel blijft dan staan, anders klapt hij in en springt het
    // hele rechterblok omhoog terwijl je de vlakken uit elkaar sleept.
    const sizeErrors = [...validateFormat(), ...validateOpeningSize()];
    if (sizeErrors.length > 0) {
      el.innerHTML = '<tr><td colspan="2" style="color:#c0392b">' + sizeErrors[0] + '</td></tr>';
      return;
    }

    const matLabel = state.material === 'linnenstof' ? T.matLinen : T.matStandard;

    let html =
      '<tr><td>' + T.labelFormat   + '</td><td>' + fmt.label    + '</td></tr>' +
      '<tr><td>' + T.labelMaterial + '</td><td>' + matLabel     + '</td></tr>' +
      '<tr><td>' + T.labelColour   + '</td><td>' + state.color  + '</td></tr>' +
      '<tr><td>' + T.labelOpenings + '</td><td>' + state.openings + '</td></tr>';

    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const label = state.openings > 1 ? T.labelOpening + ' ' + (i + 1) : T.labelInnerSize;
      html += '<tr><td>' + label + '</td><td>' +
        od.w.toFixed(1) + ' \u00d7 ' + od.h.toFixed(1) + ' cm</td></tr>';
      if (od.rotation) {
        const rotLabel = state.openings > 1 ? T.labelRotation + ' ' + (i + 1) : T.labelRotation;
        html += '<tr><td>' + rotLabel + '</td><td>' + od.rotation + '\u00b0</td></tr>';
      }
    }

    el.innerHTML = html;
  }

  // ----------------------------------------------------------------
  // Per-opening positie- en maatinvoer (dynamisch)
  // ----------------------------------------------------------------

  function getDefaultLeft(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    return ((fmt.w - od.w) / 2).toFixed(1);
  }

  function getDefaultTop(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    return ((fmt.h - od.h) / 2).toFixed(1);
  }

  function getDerivedRight(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    const left = od.left !== null ? od.left : (fmt.w - od.w) / 2;
    return Math.max(0, fmt.w - left - od.w);
  }

  function getDerivedBottom(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    const top = od.top !== null ? od.top : (fmt.h - od.h) / 2;
    return Math.max(0, fmt.h - top - od.h);
  }

  function getEffectiveLeft(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    return od.left !== null ? od.left : (fmt.w - od.w) / 2;
  }

  function getEffectiveTop(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    return od.top !== null ? od.top : (fmt.h - od.h) / 2;
  }

  function renderPositionInputs() {
    const container = document.getElementById('ppb-positions-container');
    if (!container) return;

    // Stap 5 (globale foto-upload) tonen bij 1 opening, verbergen bij meerdere
    const step5 = document.getElementById('ppb-step-foto');
    if (step5) step5.style.display = state.openings > 1 ? 'none' : '';

    let html = '';
    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const leftVal = od.left !== null ? od.left : getDefaultLeft(i);
      const topVal  = od.top  !== null ? od.top  : getDefaultTop(i);

      const isSelected = state.selectedOpenings.has(i);
      html += '<div class="ppb-position-block' + (isSelected ? ' ppb-position-block--selected' : '') + '" data-opening="' + i + '">';
      html += '<div class="ppb-position-header">';
      html += '<p class="ppb-position-label">' + T.labelOpening + ' ' + (i + 1) + '</p>';
      if (state.openings >= 2) {
        html += '<label class="ppb-select-label">' +
          '<input type="checkbox" class="ppb-select-cb" data-opening="' + i + '"' +
          (isSelected ? ' checked' : '') + '>' +
          ' ' + T.labelSelect + '</label>';
      }
      html += '</div>';

      // Binnenmaat per opening
      html +=
        '<div class="ppb-position-grid ppb-size-grid">' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-size-' + i + '-w">' + T.labelWidth + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-size-input"' +
              ' id="ppb-size-' + i + '-w" data-opening="' + i + '" data-dim="w"' +
              ' value="' + od.w + '" min="' + MIN_OPENING + '" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-size-' + i + '-h">' + T.labelHeight + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-size-input"' +
              ' id="ppb-size-' + i + '-h" data-opening="' + i + '" data-dim="h"' +
              ' value="' + od.h + '" min="' + MIN_OPENING + '" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
        '</div>';

      // Positie per opening — Links|Rechts, dan Boven|Onder
      html +=
        '<div class="ppb-position-grid">' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-pos-' + i + '-left">' + T.labelLeft + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-pos-input"' +
              ' id="ppb-pos-' + i + '-left"' +
              ' data-opening="' + i + '" data-side="left"' +
              ' value="' + leftVal + '" min="0" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-pos-' + i + '-right">' + T.labelRight + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-pos-input"' +
              ' id="ppb-pos-' + i + '-right"' +
              ' data-opening="' + i + '" data-side="right"' +
              ' value="' + getDerivedRight(i).toFixed(1) + '" min="0" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-pos-' + i + '-top">' + T.labelTop + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-pos-input"' +
              ' id="ppb-pos-' + i + '-top"' +
              ' data-opening="' + i + '" data-side="top"' +
              ' value="' + topVal + '" min="0" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-pos-' + i + '-bottom">' + T.labelBottom + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-pos-input"' +
              ' id="ppb-pos-' + i + '-bottom"' +
              ' data-opening="' + i + '" data-side="bottom"' +
              ' value="' + getDerivedBottom(i).toFixed(1) + '" min="0" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
        '</div>';

      // Rotatie-stepper
      const rot = od.rotation || 0;
      html +=
        '<div class="ppb-rotation-row">' +
          '<span class="ppb-rotation-label">' + T.labelRotate + '</span>' +
          '<button type="button" class="ppb-rotate-btn" data-opening="' + i + '" data-dir="-1">−5°</button>' +
          '<span class="ppb-rotation-display">' + rot + '°</span>' +
          '<button type="button" class="ppb-rotate-btn" data-opening="' + i + '" data-dir="1">+5°</button>' +
        '</div>';

      // Centreer-knoppen
      html +=
        '<div class="ppb-center-row">' +
          '<span class="ppb-center-label">' + T.labelCentre + '</span>' +
          '<button type="button" class="ppb-center-quick-btn" data-opening="' + i + '" data-axis="h" title="Horizontaal centreren">' +
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<rect x="3" y="5" width="12" height="8" rx="1"/>' +
              '<line x1="9" y1="1" x2="9" y2="17"/>' +
            '</svg>' +
          '</button>' +
          '<button type="button" class="ppb-center-quick-btn" data-opening="' + i + '" data-axis="v" title="Verticaal centreren">' +
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<rect x="5" y="3" width="8" height="12" rx="1"/>' +
              '<line x1="1" y1="9" x2="17" y2="9"/>' +
            '</svg>' +
          '</button>' +
          '<button type="button" class="ppb-center-quick-btn" data-opening="' + i + '" data-axis="both" title="Centreren in beide richtingen">' +
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<rect x="5" y="5" width="8" height="8" rx="1"/>' +
              '<line x1="9" y1="1" x2="9" y2="17"/>' +
              '<line x1="1" y1="9" x2="17" y2="9"/>' +
            '</svg>' +
          '</button>' +
        '</div>';

      // Standaard maten knop per opening
      html +=
        '<div class="ppb-opening-cheatsheet-row">' +
          '<button type="button" class="ppb-cheatsheet-btn ppb-cheatsheet-btn--inline" data-opening-target="' + i + '">' +
            T.cheatsheetBtn +
          '</button>' +
        '</div>';

      // Foto per opening (alleen tonen bij meerdere openingen)
      if (state.openings > 1) {
        html += '<div class="ppb-foto-per-opening">';
        if (od.photoDataUrl) {
          html +=
            '<p class="ppb-photo-filename" id="ppb-photo-name-' + i + '">' + T.photoLoaded + '</p>' +
            '<button type="button" class="ppb-photo-remove ppb-photo-remove-per"' +
            ' data-opening="' + i + '">' + T.photoRemove + '</button>';
        } else {
          html +=
            '<label for="ppb-photo-input-' + i + '" class="ppb-photo-label ppb-photo-label--small">' +
            T.photoUpload + '</label>' +
            '<input type="file" class="ppb-photo-input ppb-photo-input-per"' +
            ' id="ppb-photo-input-' + i + '" data-opening="' + i + '" accept="image/*">';
        }
        html += '</div>';
      }

      html += '</div>'; // einde ppb-position-block
    }

    container.innerHTML = html;

    // Events: centreer-knoppen per opening
    container.querySelectorAll('.ppb-center-quick-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const idx = parseInt(btn.dataset.opening, 10);
        const axis = btn.dataset.axis;
        const fmt = getActiveFormat();
        const od = state.openingPositions[idx];
        if (axis === 'h' || axis === 'both') {
          od.left = parseFloat(((fmt.w - od.w) / 2).toFixed(2));
        }
        if (axis === 'v' || axis === 'both') {
          od.top = parseFloat(((fmt.h - od.h) / 2).toFixed(2));
        }
        renderPositionInputs();
        update();
      });
    });

    // Events: binnenmaat per opening
    container.querySelectorAll('.ppb-size-input').forEach(function (inp) {
      inp.addEventListener('input', function () {
        const idx = parseInt(inp.dataset.opening, 10);
        const dim = inp.dataset.dim;
        state.openingPositions[idx][dim] = parseFloat(inp.value) || 1;
        update();
      });
    });

    // Events: positie per opening
    container.querySelectorAll('.ppb-pos-input').forEach(function (inp) {
      inp.addEventListener('input', function () {
        const idx = parseInt(inp.dataset.opening, 10);
        const side = inp.dataset.side;
        const val = parseFloat(inp.value);
        if (isNaN(val)) return;
        const fmt = getActiveFormat();
        const od = state.openingPositions[idx];

        // Bereken de nieuwe left/top voor de gewijzigde opening
        const oldLeft = od.left !== null ? od.left : (fmt.w - od.w) / 2;
        const oldTop  = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;
        let newLeft = oldLeft;
        let newTop  = oldTop;
        if (side === 'left')   newLeft = val;
        if (side === 'top')    newTop  = val;
        if (side === 'right')  newLeft = parseFloat((fmt.w - od.w - val).toFixed(2));
        if (side === 'bottom') newTop  = parseFloat((fmt.h - od.h - val).toFixed(2));

        const dLeft = newLeft - oldLeft;
        const dTop  = newTop  - oldTop;

        // Verplaats alle geselecteerde openings met dezelfde delta
        const targets = (state.selectedOpenings.size > 1 && state.selectedOpenings.has(idx))
          ? Array.from(state.selectedOpenings)
          : [idx];

        targets.forEach(function (si) {
          const sod = state.openingPositions[si];
          const sl  = sod.left !== null ? sod.left : (fmt.w - sod.w) / 2;
          const st  = sod.top  !== null ? sod.top  : (fmt.h - sod.h) / 2;
          if (side === 'left' || side === 'right')  sod.left = parseFloat((sl + dLeft).toFixed(2));
          if (side === 'top'  || side === 'bottom') sod.top  = parseFloat((st + dTop ).toFixed(2));
        });

        update();
      });
    });

    // Events: foto upload per opening
    container.querySelectorAll('.ppb-photo-input-per').forEach(function (inp) {
      inp.addEventListener('change', function () {
        const idx = parseInt(inp.dataset.opening, 10);
        const file = inp.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = function (e) {
          resizeImage(e.target.result, 800, function (resized) {
            state.openingPositions[idx].photoDataUrl = resized;
            renderPositionInputs();
            update();
          });
        };
        reader.readAsDataURL(file);
      });
    });

    // Events: foto verwijderen per opening
    container.querySelectorAll('.ppb-photo-remove-per').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const idx = parseInt(btn.dataset.opening, 10);
        state.openingPositions[idx].photoDataUrl = null;
        state.openingPositions[idx].photoW = null;
        state.openingPositions[idx].photoH = null;
        renderPositionInputs();
        update();
      });
    });

    // Events: selectie-checkboxes
    container.querySelectorAll('.ppb-select-cb').forEach(function (cb) {
      cb.addEventListener('change', function () {
        const idx = parseInt(cb.dataset.opening, 10);
        if (cb.checked) {
          state.selectedOpenings.add(idx);
        } else {
          state.selectedOpenings.delete(idx);
        }
        update();
      });
    });

    // Events: rotatie-knoppen
    container.querySelectorAll('.ppb-rotate-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        saveHistory();
        const idx = parseInt(btn.dataset.opening, 10);
        const dir = parseInt(btn.dataset.dir, 10);
        const od = state.openingPositions[idx];
        od.rotation = ((od.rotation || 0) + dir * 5 + 360) % 360;
        renderPositionInputs();
        update();
      });
    });
  }

  function updateDerivedPositions() {
    for (let i = 0; i < state.openings; i++) {
      const leftInp   = document.getElementById('ppb-pos-' + i + '-left');
      const topInp    = document.getElementById('ppb-pos-' + i + '-top');
      const rightInp  = document.getElementById('ppb-pos-' + i + '-right');
      const bottomInp = document.getElementById('ppb-pos-' + i + '-bottom');
      if (leftInp   && document.activeElement !== leftInp)   leftInp.value   = getEffectiveLeft(i).toFixed(1);
      if (topInp    && document.activeElement !== topInp)    topInp.value    = getEffectiveTop(i).toFixed(1);
      if (rightInp  && document.activeElement !== rightInp)  rightInp.value  = getDerivedRight(i).toFixed(1);
      if (bottomInp && document.activeElement !== bottomInp) bottomInp.value = getDerivedBottom(i).toFixed(1);
    }
  }

  function syncSelectionCheckboxes() {
    for (let i = 0; i < state.openings; i++) {
      const cb = document.querySelector('.ppb-select-cb[data-opening="' + i + '"]');
      if (cb) cb.checked = state.selectedOpenings.has(i);
      const block = document.querySelector('.ppb-position-block[data-opening="' + i + '"]');
      if (block) block.classList.toggle('ppb-position-block--selected', state.selectedOpenings.has(i));
    }
  }

  // ----------------------------------------------------------------
  // Shopify variant matching
  // ----------------------------------------------------------------

  // Formaat-zoekwoorden per prijsniveau. De optiewaarden zijn prijsklassen die
  // zowel het vaste formaat als de maatwerkgrens noemen ("40x50 cm of maatwerk
  // t/m 42x52 cm") en worden vertaald op /en/, dus zoeken op tekst en niet op
  // een exacte waarde. Zoektermen staan met een gewone x; has() normaliseert de
  // maalpunt uit de optiewaarde.
  const FORMAT_WORDS = {
    'small': ['klein', 'small', 'kleines', '20x25'],
    '21x30': ['a4', '21x29', '21x30'],
    '30x40': ['30x40'],
    '40x50': ['40x50'],
    '50x70': ['50x70'],
  };

  function findVariant() {
    const product = window.PassePartoutProduct;
    if (!product || !product.variants) return null;

    const baseKey = state.customFormat ? getCustomFormatBaseKey() : state.format;

    // Kleuren met toeslag (Butter Yellow) kosten net als linnenstof basis + EUR 2,
    // dus rekenen we af met de linnenstof-variant van dit formaat. Het echt
    // gekozen materiaal reist mee als line item property.
    const color     = getActiveColor();
    const surcharge = (color && color.surcharge) ? color.surcharge : 0;
    const wantLinen = state.material === 'linnenstof' || surcharge > 0;

    const fmtWords = FORMAT_WORDS[baseKey] || [];
    const matWords = wantLinen ? ['linnenstof', 'linen', 'leinen'] : ['standaard', 'standard'];

    function has(value, words) {
      const v = String(value || '').toLowerCase().replace(/\u00d7/g, 'x');
      return words.some(function (w) { return v.indexOf(w) !== -1; });
    }

    // 1. Op optiewaarden (formaat + materiaal). Werkt in elke valuta -- bezoekers
    //    uit landen met een eigen munt zien variant.price in hun eigen valuta.
    var variant = product.variants.find(function (v) {
      return has(v.option1, fmtWords) && has(v.option2, matWords);
    });

    // 2. Terugval op prijs in centen, voor het geval de optienamen veranderen.
    //    Klopt alleen zolang de bezoeker in euro's afrekent.
    if (!variant) {
      const matKey = wantLinen ? 'linnenstof' : 'standaard';
      const cents  = Math.round((PRICES[baseKey] && PRICES[baseKey][matKey] || 0) * 100);
      if (cents) {
        variant = product.variants.find(function (v) {
          return parseInt(v.price, 10) === cents;
        });
      }
    }

    return variant || null;
  }

  // ----------------------------------------------------------------
  // Cart preview SVG (compact, voor winkelwagen-thumbnail)
  // ----------------------------------------------------------------

  /**
   * Genereer een SVG-preview van het huidige ontwerp als data URI.
   * Gebruikt de state (kleur, openingen, marges) — geen DOM-capture nodig.
   * Gegarandeerd te werken als img src.
   */
  function capturePreviewFromDOM() {
    try {
      var color = getActiveColor();
      var fill  = color.hex;

      /* Openingskleur contrasteert altijd met de mat:
         lichte mat → donkergrijs opening, donkere mat → lichtgrijs opening */
      var openingFill = color.light ? '#9a9a9a' : '#d8d8d8';

      /* Altijd een vierkante thumbnail (200×200) */
      var S   = 200;
      var pad = 28; /* marge rondom formaat */

      /* SVG-achtergrond: neutraal grijs zodat zelfs witte mats zichtbaar zijn */
      var bgFill = '#d4d4d4';

      /* Probeer echte openingen te berekenen als alles valid is */
      var shapes = '';
      try {
        if (validateFormat().length === 0 && validateOpeningSize().length === 0) {
          var fmt = getActiveFormat();
          var inner = S - 2 * pad;
          var sc;
          if (fmt.w >= fmt.h) { sc = inner / fmt.w; }
          else                 { sc = inner / fmt.h; }
          var fmtW = fmt.w * sc;
          var fmtH = fmt.h * sc;
          var offX = (S - fmtW) / 2;
          var offY = (S - fmtH) / 2;

          /* Mat-rechthoek */
          shapes += '<rect x="' + offX.toFixed(1) + '" y="' + offY.toFixed(1) +
                    '" width="' + fmtW.toFixed(1) + '" height="' + fmtH.toFixed(1) +
                    '" fill="' + fill + '"/>';

          /* Openingen */
          getOpeningRects(fmt, sc).forEach(function (od) {
            shapes += '<rect x="' + (offX + od.x).toFixed(1) +
                      '" y="' + (offY + od.y).toFixed(1) +
                      '" width="' + od.w.toFixed(1) +
                      '" height="' + od.h.toFixed(1) +
                      '" fill="' + openingFill + '"/>';
          });

          /* Randje om de mat */
          shapes += '<rect x="' + offX.toFixed(1) + '" y="' + offY.toFixed(1) +
                    '" width="' + fmtW.toFixed(1) + '" height="' + fmtH.toFixed(1) +
                    '" fill="none" stroke="rgba(0,0,0,0.25)" stroke-width="1.5"/>';
        }
      } catch (_) {}

      /* Fallback: gecentreerde opening */
      if (!shapes) {
        shapes = '<rect x="' + pad + '" y="' + pad + '"' +
                 ' width="' + (S - 2 * pad) + '" height="' + (S - 2 * pad) + '"' +
                 ' fill="' + fill + '"/>' +
                 '<rect x="' + (pad + 28) + '" y="' + (pad + 28) + '"' +
                 ' width="' + (S - 2 * (pad + 28)) + '" height="' + (S - 2 * (pad + 28)) + '"' +
                 ' fill="' + openingFill + '"/>' +
                 '<rect x="' + pad + '" y="' + pad + '"' +
                 ' width="' + (S - 2 * pad) + '" height="' + (S - 2 * pad) + '"' +
                 ' fill="none" stroke="rgba(0,0,0,0.25)" stroke-width="1.5"/>';
      }

      var svg = '<svg xmlns="http://www.w3.org/2000/svg"' +
                ' viewBox="0 0 ' + S + ' ' + S + '"' +
                ' width="' + S + '" height="' + S + '">' +
                '<rect width="' + S + '" height="' + S + '" fill="' + bgFill + '"/>' +
                shapes +
                '</svg>';

      return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
    } catch (e) {
      return '';
    }
  }

  function generateCartPreviewSVG() {
    const fmt   = getActiveFormat();
    const color = getActiveColor();
    const fill  = color.hex;
    const W     = 100;
    const H     = Math.round(100 * fmt.h / fmt.w);
    const sc    = W / fmt.w;

    let rects = '';
    if (validateFormat().length === 0 && validateOpeningSize().length === 0) {
      getOpeningRects(fmt, sc).forEach(function (od) {
        rects += '<rect x="' + od.x.toFixed(1) + '" y="' + od.y.toFixed(1) +
                 '" width="' + od.w.toFixed(1) + '" height="' + od.h.toFixed(1) +
                 '" fill="white"/>';
      });
    }

    const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '">' +
                '<rect width="' + W + '" height="' + H + '" fill="' + fill + '"/>' +
                rects + '</svg>';
    try { return 'data:image/svg+xml;base64,' + btoa(svg); }
    catch (e) { return ''; }
  }

  // ----------------------------------------------------------------
  // Preview payload (voor URL-gebaseerde preview-pagina)
  // ----------------------------------------------------------------

  function buildPreviewPayload() {
    var fmt   = getActiveFormat();
    var color = getActiveColor();
    var fill  = color.hex;
    var o = getOpeningRects(fmt, 1).map(function (r) {
      return {
        x: +r.x.toFixed(1), y: +r.y.toFixed(1),
        w: +r.w.toFixed(1), h: +r.h.toFixed(1),
      };
    });
    return { w: fmt.w, h: fmt.h, fill: fill, label: fmt.label, color: state.color, o: o };
  }

  function encodePreviewParam(payload) {
    var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
  }

  // ----------------------------------------------------------------
  // Ontwerp-state coderen (voor 'bewerken vanuit winkelwagen')
  // ----------------------------------------------------------------
  //
  // Compacte, pipe-gescheiden string die als verborgen line item property
  // (_ppb_state) meereist. Formaat:
  //   1|format|customFormat|customW|customH|materiaal|kleur|openingW|openingH|
  //   left,top,w,h,rotatie;left,top,w,h,rotatie;...

  const STATE_VERSION = '1';

  function numStr(v) {
    return String(Math.round((parseFloat(v) || 0) * 100) / 100);
  }

  function serializeDesign() {
    const parts = [
      STATE_VERSION,
      state.format,
      state.customFormat ? '1' : '0',
      numStr(state.customW),
      numStr(state.customH),
      state.material === 'linnenstof' ? 'l' : 's',
      encodeURIComponent(state.color),
      numStr(state.openingW),
      numStr(state.openingH),
    ];

    const openings = [];
    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      openings.push([
        numStr(getEffectiveLeft(i)),
        numStr(getEffectiveTop(i)),
        numStr(od.w),
        numStr(od.h),
        numStr(od.rotation || 0),
      ].join(','));
    }
    parts.push(openings.join(';'));

    return parts.join('|');
  }

  function parseDesign(str) {
    if (!str) return null;
    const p = String(str).split('|');
    if (p[0] !== STATE_VERSION || p.length < 10) return null;

    const design = {
      format:       p[1],
      customFormat: p[2] === '1',
      customW:      parseFloat(p[3]),
      customH:      parseFloat(p[4]),
      material:     p[5] === 'l' ? 'linnenstof' : 'standaard',
      color:        decodeURIComponent(p[6]),
      openingW:     parseFloat(p[7]),
      openingH:     parseFloat(p[8]),
      openings:     [],
    };

    p[9].split(';').forEach(function (chunk) {
      const v = chunk.split(',').map(function (n) { return parseFloat(n); });
      if (v.length < 4 || v.slice(0, 4).some(isNaN)) return;
      design.openings.push({
        left: v[0], top: v[1], w: v[2], h: v[3],
        rotation: isNaN(v[4]) ? 0 : v[4],
      });
    });

    return design.openings.length ? design : null;
  }

  function applyDesign(design) {
    const known = FORMATS.some(function (f) { return f.key === design.format; });
    state.customFormat = design.customFormat || !known;
    if (known) state.format = design.format;
    if (!isNaN(design.customW)) state.customW = design.customW;
    if (!isNaN(design.customH)) state.customH = design.customH;
    state.material = design.material;
    if (COLORS.some(function (c) { return c.name === design.color; })) state.color = design.color;
    if (!isNaN(design.openingW)) state.openingW = design.openingW;
    if (!isNaN(design.openingH)) state.openingH = design.openingH;

    state.openings = Math.min(design.openings.length, state.openingPositions.length);
    state.selectedOpenings = new Set();
    for (let i = 0; i < state.openings; i++) {
      const src  = design.openings[i];
      const slot = state.openingPositions[i];
      slot.left     = src.left;
      slot.top      = src.top;
      slot.w        = src.w;
      slot.h        = src.h;
      slot.rotation = src.rotation;
    }

    syncUIFromState();
    renderPositionInputs();
    update();
  }

  // Zet de knoppen en invoervelden terug in lijn met de huidige state.
  function syncUIFromState() {
    document.querySelectorAll('.ppb-format-btn').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    const fmtBtn = state.customFormat
      ? document.getElementById('ppb-format-custom')
      : document.getElementById('ppb-format-' + state.format);
    if (fmtBtn) {
      fmtBtn.classList.add('is-active');
      fmtBtn.setAttribute('aria-pressed', 'true');
    }
    const customInputs = document.getElementById('ppb-custom-format-inputs');
    if (customInputs) customInputs.style.display = state.customFormat ? '' : 'none';
    const customW = document.getElementById('ppb-custom-w');
    const customH = document.getElementById('ppb-custom-h');
    if (customW) customW.value = state.customW;
    if (customH) customH.value = state.customH;

    document.querySelectorAll('.ppb-material-btn').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    const matBtn = document.getElementById('ppb-material-' + state.material);
    if (matBtn) {
      matBtn.classList.add('is-active');
      matBtn.setAttribute('aria-pressed', 'true');
    }

    document.querySelectorAll('.ppb-color-swatch').forEach(function (b) {
      const match = b.dataset.colorName === state.color;
      b.classList.toggle('is-active', match);
      b.setAttribute('aria-pressed', match ? 'true' : 'false');
    });

    document.querySelectorAll('.ppb-opening-btn').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    const openBtn   = document.getElementById('ppb-openings-' + state.openings);
    const openInput = document.getElementById('ppb-openings-custom');
    if (openBtn) {
      openBtn.classList.add('is-active');
      openBtn.setAttribute('aria-pressed', 'true');
      if (openInput) openInput.value = '';
    } else if (openInput) {
      openInput.value = state.openings;
    }

    updateColorCircleTexture();
    updateColorVisibility();
  }

  // ----------------------------------------------------------------
  // Bewerken vanuit winkelwagen
  // ----------------------------------------------------------------

  const editMode = { active: false, key: null, quantity: 1, variantId: null };

  function cartPath(suffix) {
    return (isEN ? '/en' : (isDE ? '/de' : '')) + suffix;
  }

  async function initEditMode() {
    let key;
    try {
      key = new URLSearchParams(window.location.search).get('ppb_edit');
    } catch (e) { return; }
    if (!key) return;

    let item = null;
    try {
      const res  = await fetch(cartPath('/cart.js'), { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      item = (cart.items || []).find(function (it) { return it.key === key; }) || null;
    } catch (e) { /* winkelwagen niet leesbaar — val terug op nieuw ontwerp */ }

    const design = item && item.properties ? parseDesign(item.properties._ppb_state) : null;
    if (!design) {
      if (item === null) showFeedback(T.editNotFound, 'error');
      return;
    }

    editMode.active    = true;
    editMode.key       = key;
    editMode.quantity  = item.quantity || 1;
    editMode.variantId = item.variant_id;

    applyDesign(design);
    renderEditNotice();
    updateAddButton();

    const root = document.getElementById('passe-partout-builder');
    if (root && typeof root.scrollIntoView === 'function') {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function renderEditNotice() {
    const btn = document.getElementById('ppb-add-btn');
    if (!btn || document.getElementById('ppb-edit-notice')) return;

    const notice = document.createElement('p');
    notice.className = 'ppb-edit-notice';
    notice.id = 'ppb-edit-notice';

    const text = document.createElement('span');
    text.textContent = T.editNotice;
    notice.appendChild(text);

    const cancel = document.createElement('a');
    cancel.className = 'ppb-edit-cancel';
    cancel.href = cartPath('/cart');
    cancel.textContent = T.editCancel;
    notice.appendChild(cancel);

    btn.parentNode.insertBefore(notice, btn);
  }

  // Terug naar de winkelwagen na opslaan. Even wachten zodat de
  // bevestiging nog leesbaar is voordat de pagina wisselt.
  function returnToCart() {
    const btn = document.getElementById('ppb-add-btn');
    if (btn) btn.dataset.ppbLeaving = '1';
    setTimeout(function () {
      window.location.href = cartPath('/cart');
    }, 800);
  }

  // ----------------------------------------------------------------
  // Shopify Cart API
  // ----------------------------------------------------------------

  async function addToCart() {
    const errors = validateAll();
    if (errors.length > 0) {
      showFeedback(errors[0], 'error');
      return;
    }

    const variant = findVariant();
    if (!variant) {
      showFeedback(T.productNotFound, 'error');
      return;
    }

    const fmt = getActiveFormat();
    const localePrefix = isEN ? '/en/' : (isDE ? '/de/' : '/');
    const previewUrl = window.location.origin + localePrefix + 'pages/passe-partout-preview?d=' +
                       encodePreviewParam(buildPreviewPayload());

    // Formaat en materiaal staan bewust zonder underscore: de gekozen variant is
    // alleen een prijsdrager (maatwerk valt in een prijsklasse, en een kleur met
    // toeslag rekent af via de linnenstof-variant), dus de varianttitel klopt niet
    // met het ontwerp. Zonder underscore zien klant en admin het echte formaat en
    // materiaal in winkelwagen, checkout, orderbevestiging en pakbon.
    const properties = {
      [T.cartFormat]:    fmt.label,
      [T.cartMaterial]:  state.material === 'linnenstof' ? T.cartMatLinen : T.cartMatStandard,
      [T.cartColour]:    state.color,
      [T.cartOpenings]:  String(state.openings),
      '_prijs':          getPrice().toFixed(2),
      '_ppb':            '1',
      [T.cartPreview]:   previewUrl,
    };

    for (let i = 0; i < state.openings; i++) {
      const od     = state.openingPositions[i];
      const left   = parseFloat((od.left !== null ? od.left : (fmt.w - od.w) / 2).toFixed(1));
      const top    = parseFloat((od.top  !== null ? od.top  : (fmt.h - od.h) / 2).toFixed(1));
      const right  = parseFloat((fmt.w - left - od.w).toFixed(1));
      const bottom = parseFloat((fmt.h - top  - od.h).toFixed(1));
      const pfx    = state.openings > 1 ? T.openingPrefix + (i + 1) + ' ' : '';
      properties[pfx + T.cartInnerSize]    = od.w.toFixed(1) + ' \u00d7 ' + od.h.toFixed(1) + ' cm';
      properties[pfx + T.cartMarginLeft]   = left   + ' cm';
      properties[pfx + T.cartMarginRight]  = right  + ' cm';
      properties[pfx + T.cartMarginTop]    = top    + ' cm';
      properties[pfx + T.cartMarginBottom] = bottom + ' cm';
    }

    // Verborgen ontwerp-state zodat het item later bewerkt kan worden
    properties['_ppb_state'] = serializeDesign();

    const isEdit = editMode.active;
    const addBtn = document.getElementById('ppb-add-btn');
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');
    addBtn.textContent = isEdit ? T.saving : T.adding;

    try {
      if (isEdit) {
        await saveCartEdit(variant, properties);
        showFeedback(T.savedChanges, 'success');
      } else {
        const res = await fetch(cartPath('/cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties }] }),
        });

        const resData = await res.json().catch(function () { return {}; });
        if (!res.ok) throw new Error(resData.description || 'HTTP ' + res.status);

        showFeedback(T.addedToCart, 'success');
      }

      // Open Essential Cart drawer + update cart count (niet bij bewerken —
      // daar gaan we terug naar de winkelwagen)
      if (isEdit) {
        returnToCart();
        return;
      }

      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const cartCount = document.querySelector('[data-cart-count], .cart-count, .header__cart-count');
        if (cartCount) cartCount.textContent = cart.item_count;
        // Trigger Essential Cart drawer to open
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('on:cart:updated', { detail: { cart: cart } }));
        // Also try direct drawer open methods used by different cart apps
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
      } catch (_) { /* negeren */ }

    } catch (err) {
      showFeedback((isEdit ? T.saveError : T.addError) + err.message, 'error');
    } finally {
      addBtn.classList.remove('is-loading');
      addBtn.textContent = isEdit ? T.saveChanges : T.addToCart;
      if (addBtn.dataset.ppbLeaving !== '1') addBtn.disabled = false;
    }
  }

  // Vervangt de bewerkte regel in de winkelwagen.
  // Zelfde variant  -> properties bijwerken, regel blijft op z'n plek staan.
  // Andere variant  -> eerst de nieuwe regel toevoegen, daarna de oude verwijderen,
  //                    zodat er bij een fout nooit een item verdwijnt.
  async function saveCartEdit(variant, properties) {
    const qty = editMode.quantity || 1;

    async function post(url, payload) {
      const res  = await fetch(cartPath(url), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(function () { return {}; });
      if (!res.ok) throw new Error(data.description || 'HTTP ' + res.status);
      return data;
    }

    if (variant.id === editMode.variantId) {
      await post('/cart/change.js', { id: editMode.key, quantity: qty, properties: properties });
    } else {
      await post('/cart/add.js', { items: [{ id: variant.id, quantity: qty, properties: properties }] });
      await post('/cart/change.js', { id: editMode.key, quantity: 0 });
    }

    editMode.active = false;
  }

  // ----------------------------------------------------------------
  // UI feedback
  // ----------------------------------------------------------------

  function showFeedback(msg, type) {
    const el = document.getElementById('ppb-feedback');
    if (!el) return;
    el.textContent = msg;
    el.className = 'ppb-feedback ' + (type === 'error' ? 'is-error' : 'is-success');
    if (type === 'success') {
      setTimeout(function () { el.textContent = ''; el.className = 'ppb-feedback'; }, 4000);
    }
  }

  // ----------------------------------------------------------------
  // Render / Update
  // ----------------------------------------------------------------

  function updateOverlapWarning() {
    const el = document.getElementById('ppb-overlap-warning');
    if (!el) return;
    const posErrors = validatePositions();
    // Filter on "too close" errors (both NL and EN), not border-proximity errors
    const overlapErrors = posErrors.filter(function (e) {
      return e.indexOf('te dicht bij elkaar') !== -1 || e.indexOf('too close together') !== -1;
    });
    if (overlapErrors.length > 0) {
      el.textContent = overlapErrors.join('. ') + '.';
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function update() {
    updatePreview();
    updatePrice();
    updateOpeningInfo();
    updateDerivedPositions();
    updateOverlapWarning();
    updateAddButton();
    updateAlignToolbar();
    syncSelectionCheckboxes();
  }

  function updatePreview() {
    const canvas = document.getElementById('ppb-preview-svg');
    if (!canvas) return;
    canvas.innerHTML = renderSVG();
    attachSVGInteraction();
  }

  function updatePrice() {
    const el = document.getElementById('ppb-price-value');
    if (!el) return;
    const fmtErrors = validateFormat();
    if (fmtErrors.length > 0) {
      el.textContent = '\u2013';
      return;
    }
    const price = getPrice();
    let label = formatPrice(price);
    if (state.customFormat) {
      const baseKey = getCustomFormatBaseKey();
      const baseFmt = FORMATS.find(function (f) { return f.key === baseKey; });
      const baseLabel = baseFmt ? baseFmt.label : tri('Small size', 'Klein formaat', 'Kleines Format');
      label += T.basedOn.replace('{label}', baseLabel);
    }
    el.textContent = label;
  }

  function updateAddButton() {
    const btn = document.getElementById('ppb-add-btn');
    if (!btn) return;
    const errors = validateAll();
    btn.disabled = errors.length > 0;
    if (editMode.active && !btn.classList.contains('is-loading')) btn.textContent = T.saveChanges;

    const errEl = document.getElementById('ppb-opening-error');
    if (errEl) {
      const sizeErrors = validateOpeningSize();
      const posErrors  = validatePositions();
      const relevant = [...sizeErrors, ...posErrors];
      errEl.textContent = relevant.length > 0 ? relevant[0] : '';
    }
  }

  function centerInFrame(axis) {
    const fmt = getActiveFormat();
    const indices = Array.from(state.selectedOpenings);
    if (!indices.length) return;
    saveHistory();

    const snapshots = indices.map(function (i) {
      return { i: i, left: state.openingPositions[i].left, top: state.openingPositions[i].top };
    });

    // Pre-compute effective positions zodat we de groep als geheel kunnen centreren
    const eff = {};
    indices.forEach(function (i) {
      eff[i] = { left: getEffectiveLeft(i), top: getEffectiveTop(i) };
    });

    if (axis === 'h' || axis === 'both') {
      let minLeft = Infinity, maxRight = -Infinity;
      indices.forEach(function (i) {
        minLeft  = Math.min(minLeft,  eff[i].left);
        maxRight = Math.max(maxRight, eff[i].left + state.openingPositions[i].w);
      });
      const dLeft = (fmt.w - (maxRight - minLeft)) / 2 - minLeft;
      indices.forEach(function (i) {
        state.openingPositions[i].left = parseFloat((eff[i].left + dLeft).toFixed(2));
      });
    }

    if (axis === 'v' || axis === 'both') {
      let minTop = Infinity, maxBottom = -Infinity;
      indices.forEach(function (i) {
        minTop    = Math.min(minTop,    eff[i].top);
        maxBottom = Math.max(maxBottom, eff[i].top + state.openingPositions[i].h);
      });
      const dTop = (fmt.h - (maxBottom - minTop)) / 2 - minTop;
      indices.forEach(function (i) {
        state.openingPositions[i].top = parseFloat((eff[i].top + dTop).toFixed(2));
      });
    }

    var errors = validatePositions();
    if (errors.length > 0) {
      snapshots.forEach(function (s) {
        state.openingPositions[s.i].left = s.left;
        state.openingPositions[s.i].top  = s.top;
      });
      var alignErr = document.getElementById('ppb-align-error');
      if (alignErr) {
        alignErr.textContent = T.centreFailed + errors[0].toLowerCase();
        alignErr.style.display = '';
        clearTimeout(alignErr._timer);
        alignErr._timer = setTimeout(function () {
          alignErr.style.display = 'none';
          alignErr.textContent = '';
        }, 5000);
      }
      return;
    }

    var alignErr = document.getElementById('ppb-align-error');
    if (alignErr) { alignErr.style.display = 'none'; alignErr.textContent = ''; }

    renderPositionInputs();
    update();
  }

  function updateAlignToolbar() {
    const toolbar = document.getElementById('ppb-align-toolbar');
    if (!toolbar) return;
    const n = state.selectedOpenings.size;
    const show = n >= 1;
    toolbar.style.display = show ? '' : 'none';
    toolbar.setAttribute('aria-hidden', show ? 'false' : 'true');
    // Uitlijn-knoppen (links/rechts/boven/onder) alleen actief bij ≥2
    toolbar.querySelectorAll('.ppb-multi-btn').forEach(function (btn) {
      btn.disabled = n < 2;
      btn.style.opacity = n < 2 ? '0.35' : '';
    });
  }

  // ----------------------------------------------------------------
  // SVG drag & resize interactie
  // ----------------------------------------------------------------

  // Snappen tijdens verslepen. `box` is het blok dat beweegt (één opening, of
  // de omhullende van alle geselecteerde openingen), `moving` de indices die
  // meebewegen. Het midden van het blok klikt vast op het kadermidden, en elke
  // rand of elk midden op die van de andere openingen. Vastgeklikt ligt het
  // blok exact op de lijn; daarbuiten springt het per hele millimeter.
  // Geeft { left, top, lines } terug, lines in cm.
  function snapMove(box, moving, threshCm) {
    const fmt = getActiveFormat();
    const refsX = [{ pos: fmt.w / 2, center: true }];
    const refsY = [{ pos: fmt.h / 2, center: true }];
    for (let i = 0; i < state.openings; i++) {
      if (moving.has(i)) continue;
      const od = state.openingPositions[i];
      const l = getEffectiveLeft(i), t = getEffectiveTop(i);
      [l, l + od.w, l + od.w / 2].forEach(function (p) { refsX.push({ pos: p }); });
      [t, t + od.h, t + od.h / 2].forEach(function (p) { refsY.push({ pos: p }); });
    }

    function snapAxis(start, size, refs) {
      let best = null;
      [[0, false], [size, false], [size / 2, true]].forEach(function (c) {
        refs.forEach(function (ref) {
          if (ref.center && !c[1]) return; // kadermidden alleen voor het midden van het blok
          const d = Math.abs(start + c[0] - ref.pos);
          if (d <= threshCm && (!best || d < best.d)) best = { d: d, start: ref.pos - c[0] };
        });
      });
      return best ? best.start : Math.round(start * 10) / 10;
    }

    const left = snapAxis(box.left, box.w, refsX);
    const top  = snapAxis(box.top,  box.h, refsY);

    // Hulplijnen: elke referentie waar het blok nu precies op ligt
    const lines = [];
    const seen = new Set();
    function addLines(start, size, refs, axis) {
      refs.forEach(function (ref) {
        [start, start + size, start + size / 2].forEach(function (p, k) {
          if (ref.center && k !== 2) return;
          const key = axis + ref.pos.toFixed(3);
          if (Math.abs(p - ref.pos) < 0.001 && !seen.has(key)) {
            seen.add(key);
            lines.push({ axis: axis, pos: ref.pos, center: !!ref.center });
          }
        });
      });
    }
    addLines(left, box.w, refsX, 'v');
    addLines(top,  box.h, refsY, 'h');

    return { left: left, top: top, lines: lines };
  }

  function getSVGScale() {
    const fmt = getActiveFormat();
    return Math.min(340 / fmt.w, 420 / fmt.h);
  }

  // Schermpixels per SVG-eenheid. CSS tekent de SVG vaak kleiner dan zijn
  // eigen breedte (op mobiel 100% breed, op desktop max. 400px hoog); zonder
  // deze factor loopt een opening niet gelijk op met de muis of vinger.
  // CSS kan breedte en hoogte los beperken; de viewBox schaalt dan met de
  // kleinste van de twee, en dat is precies wat de schermmatrix teruggeeft.
  function getRenderRatio(svg) {
    const ctm = svg.getScreenCTM && svg.getScreenCTM();
    if (ctm && ctm.a > 0) return ctm.a;
    const vb = svg.viewBox && svg.viewBox.baseVal;
    const r = svg.getBoundingClientRect();
    return vb && vb.width && r.width ? Math.min(r.width / vb.width, r.height / vb.height) : 1;
  }

  const COARSE_POINTER = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

  function attachSVGInteraction() {
    const container = document.getElementById('ppb-preview-svg');
    if (!container) return;
    const svg = container.querySelector('svg');
    if (!svg) return;

    const sizeErrors = [...validateFormat(), ...validateOpeningSize()];
    if (sizeErrors.length > 0) return;

    const fmt   = getActiveFormat();
    const scale = getSVGScale();
    const ratio = getRenderRatio(svg);
    // Zichtbaar hoekje ~9 schermpixels; het grijpvlak eromheen is groter,
    // op een touchscreen ruim een vingertop.
    const HANDLE = 9 / ratio;
    const HIT    = (COARSE_POINTER ? 34 : 16) / ratio;

    for (let i = 0; i < state.openings; i++) {
      const od   = state.openingPositions[i];
      const left = od.left !== null ? od.left : (fmt.w - od.w) / 2;
      const top  = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;

      const rx = left * scale;
      const ry = top  * scale;
      const rw = od.w  * scale;
      const rh = od.h  * scale;
      const rot = od.rotation || 0;

      // Groep met rotatie-transform zodat handles mee-roteren
      const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      if (rot) {
        const cx = (rx + rw / 2).toFixed(1);
        const cy = (ry + rh / 2).toFixed(1);
        g.setAttribute('transform', 'rotate(' + rot + ',' + cx + ',' + cy + ')');
      }
      svg.appendChild(g);

      // Transparante overlay voor verplaatsen
      addSVGHandle(g, rx, ry, rw, rh, 'transparent', 'move', i, 'move', '');

      // Resize-hoekjes: grijpvlak gecentreerd op de hoek, nooit meer dan een
      // derde van de opening zodat er genoeg overblijft om te verplaatsen
      const hit = Math.min(HIT, rw / 3 * 2, rh / 3 * 2);
      const corners = [
        { x: rx,      y: ry,      cur: 'nw-resize', d: 'nw', vx: 0,           vy: 0 },
        { x: rx + rw, y: ry,      cur: 'ne-resize', d: 'ne', vx: rw - HANDLE, vy: 0 },
        { x: rx,      y: ry + rh, cur: 'sw-resize', d: 'sw', vx: 0,           vy: rh - HANDLE },
        { x: rx + rw, y: ry + rh, cur: 'se-resize', d: 'se', vx: rw - HANDLE, vy: rh - HANDLE },
      ];
      corners.forEach(function (c) {
        addSVGHandle(g, c.x - hit / 2, c.y - hit / 2, hit, hit, 'transparent', c.cur, i, 'resize', c.d);
      });
      corners.forEach(function (c) {
        const v = addSVGHandle(g, rx + c.vx, ry + c.vy, HANDLE, HANDLE,
          'rgba(255,255,255,0.85)', c.cur, i, 'resize', c.d);
        v.setAttribute('stroke-width', (1.5 / ratio).toFixed(2));
        v.style.pointerEvents = 'none';
      });
    }
  }

  function addSVGHandle(parent, x, y, w, h, fill, cursor, idx, action, dir) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    el.setAttribute('x', x.toFixed(1));
    el.setAttribute('y', y.toFixed(1));
    el.setAttribute('width',  w.toFixed(1));
    el.setAttribute('height', h.toFixed(1));
    el.setAttribute('fill', fill);
    el.style.cursor = cursor;
    el.dataset.ppbOpening = String(idx);
    el.dataset.ppbAction  = action;
    el.dataset.ppbDir     = dir;
    if (action === 'resize' && fill !== 'transparent') {
      el.setAttribute('stroke', '#1e61b9');
      el.setAttribute('stroke-width', '1.5');
      el.setAttribute('rx', '2');
    }
    parent.appendChild(el);
    return el;
  }

  // Slepen gaat via pointer events op de vaste container rond de SVG. De SVG
  // zelf wordt bij elke beweging opnieuw opgebouwd; met touch events hield een
  // iPhone dan op met doorgeven zodra het aangeraakte element verdween. Met
  // pointer capture op de container blijven muis, vinger en pen gewoon volgen.
  function onSVGPointerDown(e) {
    if (e.button > 0) return; // alleen de primaire muisknop
    // Een tweede vinger negeren we; een nieuwe eerste aanraking wint altijd,
    // zodat een gemiste pointerup de builder nooit laat vastlopen
    if (svgDrag && !e.isPrimary) return;
    const target = e.target;
    if (!target || !target.ownerSVGElement && target.tagName !== 'svg') return;

    // Tik/klik op achtergrond (geen opening-handle): selectie wissen
    if (target.dataset.ppbOpening === undefined) {
      if (state.selectedOpenings.size > 0) {
        e.preventDefault();
        state.selectedOpenings = new Set();
        update();
      }
      return;
    }
    e.preventDefault();

    const fmt   = getActiveFormat();
    const scale = getSVGScale();
    const svg   = target.ownerSVGElement || target;
    const i     = parseInt(target.dataset.ppbOpening, 10);
    const od    = state.openingPositions[i];
    const left  = od.left !== null ? od.left : (fmt.w - od.w) / 2;
    const top   = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;

    // Sla startposities én -afmetingen op van alle geselecteerde openings
    const origPositions = {};
    const origSizes = {};
    state.selectedOpenings.forEach(function (si) {
      const sod = state.openingPositions[si];
      const sl  = sod.left !== null ? sod.left : (fmt.w - sod.w) / 2;
      const st  = sod.top  !== null ? sod.top  : (fmt.h - sod.h) / 2;
      origPositions[si] = { left: sl, top: st };
      origSizes[si]     = { w: sod.w, h: sod.h, cx: sl + sod.w / 2, cy: st + sod.h / 2 };
    });

    svgDrag = {
      idx:          i,
      action:       target.dataset.ppbAction,
      dir:          target.dataset.ppbDir || '',
      startX:       e.clientX,
      startY:       e.clientY,
      origLeft:     left,
      origTop:      top,
      origW:        od.w,
      origH:        od.h,
      origPositions: origPositions,
      origSizes:    origSizes,
      scale:        scale,
      pxPerCm:      scale * getRenderRatio(svg),
      snapPx:       e.pointerType === 'touch' ? 10 : 6,
      pointerId:    e.pointerId,
      fmt:          fmt,
      moved:        false,
    };
    try { e.currentTarget.setPointerCapture(e.pointerId); } catch (_) {}
  }

  function initSVGDragListeners() {
    const container = document.getElementById('ppb-preview-svg');
    if (!container) return;
    var rafPending = false;

    function onMove(e) {
      if (!svgDrag || e.pointerId !== svgDrag.pointerId) return;

      // Markeer als drag zodra de vinger/muis >3px beweegt
      if (!svgDrag.moved) {
        var totalDx = Math.abs(e.clientX - svgDrag.startX);
        var totalDy = Math.abs(e.clientY - svgDrag.startY);
        if (totalDx <= 3 && totalDy <= 3) return;
        svgDrag.moved = true;
        saveHistory(); // pas bij echt slepen, zodat een tik geen ongedaan-stap kost
      }

      e.preventDefault();

      // Throttle via requestAnimationFrame
      svgDrag._lastCoords = { clientX: e.clientX, clientY: e.clientY };
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        if (!svgDrag) return;
        processMove(svgDrag._lastCoords);
      });
    }

    function clamp(v, min, max) { return Math.max(min, Math.min(v, max)); }

    function processMove(coords) {
      const d   = svgDrag;
      const fmt = d.fmt;
      const dx  = (coords.clientX - d.startX) / d.pxPerCm;
      const dy  = (coords.clientY - d.startY) / d.pxPerCm;
      const od  = state.openingPositions[d.idx];
      const thresh = d.snapPx / d.pxPerCm;

      if (d.action === 'move') {
        const group = state.selectedOpenings.size > 1 && state.selectedOpenings.has(d.idx);
        const moving = group ? state.selectedOpenings : new Set([d.idx]);
        const orig = group ? d.origPositions : {};
        if (!group) orig[d.idx] = { left: d.origLeft, top: d.origTop };

        // Omhullende van alles wat beweegt; die schuift en snapt als één blok
        let minL = Infinity, minT = Infinity, maxR = -Infinity, maxB = -Infinity;
        moving.forEach(function (si) {
          const o = orig[si];
          if (!o) return;
          const sod = state.openingPositions[si];
          minL = Math.min(minL, o.left); minT = Math.min(minT, o.top);
          maxR = Math.max(maxR, o.left + sod.w); maxB = Math.max(maxB, o.top + sod.h);
        });
        const bw = maxR - minL, bh = maxB - minT;
        const maxLeft = fmt.w - bw - MIN_MARGIN, maxTop = fmt.h - bh - MIN_MARGIN;

        const box = {
          left: clamp(minL + dx, MIN_MARGIN, maxLeft),
          top:  clamp(minT + dy, MIN_MARGIN, maxTop),
          w: bw, h: bh,
        };
        const snap = snapMove(box, moving, thresh);
        const newLeft = clamp(snap.left, MIN_MARGIN, maxLeft);
        const newTop  = clamp(snap.top,  MIN_MARGIN, maxTop);

        moving.forEach(function (si) {
          const o = orig[si];
          if (!o) return;
          const sod = state.openingPositions[si];
          sod.left = parseFloat((o.left + newLeft - minL).toFixed(2));
          sod.top  = parseFloat((o.top  + newTop  - minT).toFixed(2));
        });
        snapLines = snap.lines.filter(function (l) {
          return l.axis === 'v' ? newLeft === snap.left : newTop === snap.top;
        });
      } else {
        // resize
        let newLeft = d.origLeft;
        let newTop  = d.origTop;
        let newW    = d.origW;
        let newH    = d.origH;

        if (d.dir.includes('e')) newW = Math.max(MIN_OPENING, d.origW + dx);
        if (d.dir.includes('s')) newH = Math.max(MIN_OPENING, d.origH + dy);
        if (d.dir.includes('w')) { newW = Math.max(MIN_OPENING, d.origW - dx); newLeft = d.origLeft + (d.origW - newW); }
        if (d.dir.includes('n')) { newH = Math.max(MIN_OPENING, d.origH - dy); newTop  = d.origTop  + (d.origH - newH); }

        newLeft = Math.max(MIN_MARGIN, newLeft);
        newTop  = Math.max(MIN_MARGIN, newTop);
        if (newLeft + newW > fmt.w - MIN_MARGIN) newW = fmt.w - MIN_MARGIN - newLeft;
        if (newTop  + newH > fmt.h - MIN_MARGIN) newH = fmt.h - MIN_MARGIN - newTop;

        od.w    = parseFloat(newW.toFixed(1));
        od.h    = parseFloat(newH.toFixed(1));
        od.left = parseFloat(newLeft.toFixed(2));
        od.top  = parseFloat(newTop.toFixed(2));

        // Multi-resize: pas dezelfde schaalfactor toe op alle andere geselecteerde openings
        if (state.selectedOpenings.size > 1 && state.selectedOpenings.has(d.idx)) {
          const scaleW = d.origW > 0 ? newW / d.origW : 1;
          const scaleH = d.origH > 0 ? newH / d.origH : 1;
          state.selectedOpenings.forEach(function (si) {
            if (si === d.idx) return;
            const orig = d.origSizes[si];
            if (!orig) return;
            const sod  = state.openingPositions[si];
            sod.w = parseFloat(Math.max(MIN_OPENING, orig.w * scaleW).toFixed(1));
            sod.h = parseFloat(Math.max(MIN_OPENING, orig.h * scaleH).toFixed(1));
            // Positie ongewijzigd — top-left blijft staan
            const origPos = d.origPositions[si];
            if (origPos) {
              sod.left = parseFloat(Math.max(MIN_MARGIN, origPos.left).toFixed(2));
              sod.top  = parseFloat(Math.max(MIN_MARGIN, origPos.top).toFixed(2));
            }
          });
        }
      }

      // Alleen SVG + info hertekenen tijdens slepen (snel)
      updatePreview();
      updateOpeningInfo();
      updateAddButton();
      updateOverlapWarning();
    }

    function onEnd(e) {
      if (!svgDrag || e.pointerId !== svgDrag.pointerId) return;
      const d = svgDrag;
      svgDrag = null;
      snapLines = [];
      try { container.releasePointerCapture(e.pointerId); } catch (_) {}

      if (!d.moved) {
        if (e.type === 'pointercancel') return;
        // Tik/klik: toggle selectie
        const idx = d.idx;
        if (e.shiftKey || e.metaKey || e.ctrlKey) { // ⌘, Ctrl of Shift: selectie uitbreiden
          if (state.selectedOpenings.has(idx)) {
            state.selectedOpenings.delete(idx);
          } else {
            state.selectedOpenings.add(idx);
          }
        } else {
          if (state.selectedOpenings.has(idx) && state.selectedOpenings.size === 1) {
            state.selectedOpenings.delete(idx);
          } else {
            state.selectedOpenings = new Set([idx]);
          }
        }
        update();
        return;
      }

      // Drag/swipe voltooid
      syncOpeningSizeInputs();
      renderPositionInputs();
      update();
    }

    container.addEventListener('pointerdown', onSVGPointerDown);
    container.addEventListener('pointermove', onMove);
    container.addEventListener('pointerup', onEnd);
    container.addEventListener('pointercancel', onEnd);
  }

  // ----------------------------------------------------------------
  // Foto resize via canvas
  // ----------------------------------------------------------------

  function resizeImage(dataUrl, maxPx, callback) {
    const img = new Image();
    img.onload = function () {
      const scale = Math.min(1, maxPx / img.width, maxPx / img.height);
      const w = Math.round(img.width  * scale);
      const h = Math.round(img.height * scale);
      const canvas = document.createElement('canvas');
      canvas.width  = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      callback(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.src = dataUrl;
  }

  // ----------------------------------------------------------------
  // Event bindings
  // ----------------------------------------------------------------

  function syncOpeningSizeInputs() {
    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const wInp = document.getElementById('ppb-size-' + i + '-w');
      const hInp = document.getElementById('ppb-size-' + i + '-h');
      if (wInp) wInp.value = od.w;
      if (hInp) hInp.value = od.h;
    }
  }

  function updateColorCircleTexture() {
    const isLinnen = state.material === 'linnenstof';
    document.querySelectorAll('.ppb-color-circle').forEach(function (el) {
      el.classList.toggle('ppb-color-circle--linnen', isLinnen);
      el.classList.toggle('ppb-color-circle--karton', !isLinnen);
    });
  }

  function updateColorVisibility() {
    const mat = state.material;
    // state.material is 'standaard' or 'linnenstof'; data-material is 'karton' or 'linnenstof'
    const materialKey = mat === 'standaard' ? 'karton' : mat;
    let activeUsable = false;
    document.querySelectorAll('.ppb-color-swatch[data-material]').forEach(function (btn) {
      const visible = btn.dataset.material === materialKey;
      btn.style.display = visible ? '' : 'none';
      if (visible && !btn.disabled && btn.classList.contains('is-active')) activeUsable = true;
    });
    // Als de geselecteerde kleur niet beschikbaar is (ander materiaal of uitverkocht),
    // switch naar de voorkeurskleur, of anders naar de eerste kleur die wel te kiezen is
    if (!activeUsable) {
      const preferred = mat === 'linnenstof' ? 'Linnen 2' : 'Canvas Cream';
      let fallbackBtn = null;
      document.querySelectorAll('.ppb-color-swatch[data-material="' + materialKey + '"]').forEach(function (b) {
        if (b.disabled) return;
        if (fallbackBtn === null || b.dataset.colorName === preferred) fallbackBtn = b;
      });
      if (fallbackBtn) {
        state.color = fallbackBtn.dataset.colorName;
        document.querySelectorAll('.ppb-color-swatch').forEach(function (b) {
          const match = b === fallbackBtn;
          b.classList.toggle('is-active', match);
          b.setAttribute('aria-pressed', match ? 'true' : 'false');
        });
      }
    }
  }

  function resetPositions() {
    for (let i = 0; i < 4; i++) {
      state.openingPositions[i].left = null;
      state.openingPositions[i].top  = null;
    }
  }

  // Verdeelt N openingen gelijkmatig over het canvas.
  // Elke opening krijgt de maat van opening 1, zodat een ingevulde maat blijft
  // staan als je daarna een ander aantal kiest. Het raster wordt zo gekozen dat
  // die maat past; alleen als hij in geen enkel raster past, worden alle
  // openingen naar verhouding kleiner (vorm blijft gelijk).
  function computeAutoLayout() {
    const fmt = getActiveFormat();
    const n = state.openings;

    if (state.openingPositions[0].w > 0 && state.openingPositions[0].h > 0) {
      state.openingW = state.openingPositions[0].w;
      state.openingH = state.openingPositions[0].h;
    }

    // Reset posities voor alle slots
    for (let i = 0; i < state.openingPositions.length; i++) {
      state.openingPositions[i].left = null;
      state.openingPositions[i].top  = null;
    }

    if (n <= 1) {
      var maxW1 = Math.max(1, fmt.w - 2 * MIN_MARGIN);
      var maxH1 = Math.max(1, fmt.h - 2 * MIN_MARGIN);
      state.openingPositions[0].w = parseFloat(Math.min(state.openingW, maxW1).toFixed(1));
      state.openingPositions[0].h = parseFloat(Math.min(state.openingH, maxH1).toFixed(1));
      return;
    }

    const usableW = fmt.w - 2 * MIN_MARGIN;
    const usableH = fmt.h - 2 * MIN_MARGIN;

    // Ruimste tussenruimte (hoogstens LAYOUT_GAP) waarmee de maat in een
    // raster van `cols` kolommen past; minder dan MIN_GAP betekent: past niet
    function gapFor(cols) {
      const rows = Math.ceil(n / cols);
      const gw = cols > 1 ? (usableW - cols * state.openingW) / (cols - 1) : (usableW >= state.openingW ? LAYOUT_GAP : -1);
      const gh = rows > 1 ? (usableH - rows * state.openingH) / (rows - 1) : (usableH >= state.openingH ? LAYOUT_GAP : -1);
      return Math.min(LAYOUT_GAP, gw, gh);
    }

    // Hoeveel moet de maat krimpen bij de kleinste tussenruimte (1 = past)
    function fitFactor(cols) {
      const rows = Math.ceil(n / cols);
      const maxW = (usableW - (cols - 1) * MIN_GAP) / cols;
      const maxH = (usableH - (rows - 1) * MIN_GAP) / rows;
      return Math.min(1, maxW / state.openingW, maxH / state.openingH);
    }

    // Voorkeursraster: 2 → naast elkaar, 3 → op een rij, verder zo vierkant mogelijk.
    // Past de maat daar niet in, dan het raster met de ruimste tussenruimte.
    const preferred = n <= 3 ? n : Math.ceil(Math.sqrt(n));
    let cols = preferred, gap = gapFor(preferred), best = 1;
    if (gap < LAYOUT_GAP - 1e-9) {
      for (let c = 1; c <= n; c++) {
        const g = gapFor(c);
        if (g > gap + 1e-9) { gap = g; cols = c; }
      }
    }
    if (gap < MIN_GAP - 1e-9) {
      // Past in geen enkel raster: naar verhouding verkleinen
      best = 0;
      for (let c = 1; c <= n; c++) {
        const f = fitFactor(c);
        if (f > best + 1e-9 || (Math.abs(f - best) < 1e-9 && Math.abs(c - preferred) < Math.abs(cols - preferred))) {
          best = f; cols = c;
        }
      }
      gap = MIN_GAP;
    }
    gap = Math.floor(gap * 10) / 10; // tussenruimte in hele millimeters
    const rows = Math.ceil(n / cols);

    const fitW = Math.max(1, Math.floor(state.openingW * best * 10) / 10);
    const fitH = Math.max(1, Math.floor(state.openingH * best * 10) / 10);

    const gridW  = cols * fitW + (cols - 1) * gap;
    const gridH  = rows * fitH + (rows - 1) * gap;
    const startX = Math.max(MIN_MARGIN, (fmt.w - gridW) / 2);
    const startY = Math.max(MIN_MARGIN, (fmt.h - gridH) / 2);

    let idx = 0;
    for (let r = 0; r < rows && idx < n; r++) {
      for (let c = 0; c < cols && idx < n; c++) {
        state.openingPositions[idx].w    = fitW;
        state.openingPositions[idx].h    = fitH;
        state.openingPositions[idx].left = parseFloat((startX + c * (fitW + gap)).toFixed(2));
        state.openingPositions[idx].top  = parseFloat((startY + r * (fitH + gap)).toFixed(2));
        idx++;
      }
    }
  }

  function bindEvents() {
    // Stap 1 — Vaste formaten
    FORMATS.forEach(function (fmt) {
      const btn = document.getElementById('ppb-format-' + fmt.key);
      if (!btn) return;
      btn.addEventListener('click', function () {
        state.format = fmt.key;
        state.customFormat = false;
        document.querySelectorAll('.ppb-format-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        const customInputs = document.getElementById('ppb-custom-format-inputs');
        if (customInputs) customInputs.style.display = 'none';
        const customErr = document.getElementById('ppb-format-error');
        if (customErr) customErr.textContent = '';
        // Clip template + per-opening afmetingen naar nieuw formaat
        const f = getActiveFormat();
        state.openingW = Math.min(state.openingW, f.w - 2 * MIN_MARGIN);
        state.openingH = Math.min(state.openingH, f.h - 2 * MIN_MARGIN);
        for (let i = 0; i < state.openingPositions.length; i++) {
          state.openingPositions[i].w = Math.min(state.openingPositions[i].w, f.w - 2 * MIN_MARGIN);
          state.openingPositions[i].h = Math.min(state.openingPositions[i].h, f.h - 2 * MIN_MARGIN);
        }
        computeAutoLayout();
        syncOpeningSizeInputs();
        renderPositionInputs();
        update();
      });
    });

    // Stap 1 — Eigen formaat knop
    const customBtn = document.getElementById('ppb-format-custom');
    if (customBtn) {
      customBtn.addEventListener('click', function () {
        state.customFormat = true;
        document.querySelectorAll('.ppb-format-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        customBtn.classList.add('is-active');
        customBtn.setAttribute('aria-pressed', 'true');
        const customInputs = document.getElementById('ppb-custom-format-inputs');
        if (customInputs) customInputs.style.display = '';
        computeAutoLayout();
        syncOpeningSizeInputs();
        renderPositionInputs();
        update();
      });
    }

    // Stap 1 — Custom formaat invoer
    const customWInput = document.getElementById('ppb-custom-w');
    const customHInput = document.getElementById('ppb-custom-h');
    if (customWInput) {
      customWInput.addEventListener('input', function () {
        state.customW = parseFloat(customWInput.value) || 21;
        const errEl = document.getElementById('ppb-format-error');
        if (errEl) errEl.textContent = validateFormat()[0] || '';
        computeAutoLayout(); syncOpeningSizeInputs();
        if (state.openings > 1) renderPositionInputs();
        update();
      });
    }
    if (customHInput) {
      customHInput.addEventListener('input', function () {
        state.customH = parseFloat(customHInput.value) || 30;
        const errEl = document.getElementById('ppb-format-error');
        if (errEl) errEl.textContent = validateFormat()[0] || '';
        computeAutoLayout(); syncOpeningSizeInputs();
        if (state.openings > 1) renderPositionInputs();
        update();
      });
    }

    // Stap 2 — Materiaal
    ['standaard', 'linnenstof'].forEach(function (mat) {
      var btn = document.getElementById('ppb-material-' + mat);
      if (!btn) return;
      btn.addEventListener('click', function () {
        state.material = mat;
        document.querySelectorAll('.ppb-material-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        updateColorCircleTexture();
        updateColorVisibility();
        update();
      });
    });

    // Stap 3 — Kleuren
    document.querySelectorAll('.ppb-color-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.color = btn.dataset.colorName;
        document.querySelectorAll('.ppb-color-swatch').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        update();
      });
    });

    // Stap 4 — Openingen (aantal)
    function setOpenings(n) {
      state.openings = n;
      state.selectedOpenings = new Set();
      computeAutoLayout();
      syncOpeningSizeInputs();
      document.querySelectorAll('.ppb-opening-btn').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      const fixedBtn = document.getElementById('ppb-openings-' + n);
      if (fixedBtn) {
        fixedBtn.classList.add('is-active');
        fixedBtn.setAttribute('aria-pressed', 'true');
      }
      renderPositionInputs();
      update();
    }

    [1, 2, 3, 4].forEach(function (n) {
      const btn = document.getElementById('ppb-openings-' + n);
      if (!btn) return;
      btn.addEventListener('click', function () {
        const customInput = document.getElementById('ppb-openings-custom');
        if (customInput) customInput.value = '';
        setOpenings(n);
      });
    });

    const customOpeningInput = document.getElementById('ppb-openings-custom');
    if (customOpeningInput) {
      customOpeningInput.addEventListener('input', function () {
        const val = parseInt(this.value, 10);
        if (!val || val < 1 || val > 20) return;
        document.querySelectorAll('.ppb-opening-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        setOpenings(val);
      });
    }

    // Stap 5 — Foto upload (alleen voor 1 opening; bij meerdere loopt dit via renderPositionInputs)
    const photoInput = document.getElementById('ppb-photo-input');
    if (photoInput) {
      photoInput.addEventListener('change', function () {
        const file = photoInput.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = function (e) {
          resizeImage(e.target.result, 800, function (resized) {
            state.openingPositions[0].photoDataUrl = resized;
            const details   = document.getElementById('ppb-photo-details');
            const filename  = document.getElementById('ppb-photo-filename');
            const removeBtn = document.getElementById('ppb-photo-remove');
            if (details)   details.style.display  = '';
            if (filename)  filename.textContent    = file.name;
            if (removeBtn) removeBtn.style.display = '';
            update();
          });
        };
        reader.readAsDataURL(file);
      });
    }

    const photoWInput = document.getElementById('ppb-photo-w');
    const photoHInput = document.getElementById('ppb-photo-h');
    if (photoWInput) {
      photoWInput.addEventListener('input', function () {
        const val = parseFloat(photoWInput.value);
        state.openingPositions[0].photoW = isNaN(val) ? null : val;
        update();
      });
    }
    if (photoHInput) {
      photoHInput.addEventListener('input', function () {
        const val = parseFloat(photoHInput.value);
        state.openingPositions[0].photoH = isNaN(val) ? null : val;
        update();
      });
    }

    const photoRemoveBtn = document.getElementById('ppb-photo-remove');
    if (photoRemoveBtn) {
      photoRemoveBtn.addEventListener('click', function () {
        state.openingPositions[0].photoDataUrl = null;
        state.openingPositions[0].photoW = null;
        state.openingPositions[0].photoH = null;
        if (photoInput) photoInput.value = '';
        const details = document.getElementById('ppb-photo-details');
        if (details) details.style.display = 'none';
        photoRemoveBtn.style.display = 'none';
        update();
      });
    }

    // Toevoegen aan winkelwagen
    const addBtn = document.getElementById('ppb-add-btn');
    if (addBtn) addBtn.addEventListener('click', onAddClick);

    // Alignment-toolbar knoppen
    document.querySelectorAll('.ppb-align-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.dataset.align;
        if (action === 'center-h')    centerInFrame('h');
        else if (action === 'center-v')    centerInFrame('v');
        else if (action === 'center-both') centerInFrame('both');
        else alignOpenings(action);
      });
    });

    function distributeOpenings(axis) {
      const indices = Array.from(state.selectedOpenings);
      if (indices.length < 2) return;
      saveHistory();
      const gapInput = document.getElementById('ppb-distribute-gap');
      const gap = Math.max(0, parseFloat(gapInput ? gapInput.value : 2) || 2);

      if (axis === 'h') {
        // Sorteer op huidige left-positie, eerste blijft staan
        indices.sort(function (a, b) { return getEffectiveLeft(a) - getEffectiveLeft(b); });
        let cursor = getEffectiveLeft(indices[0]);
        state.openingPositions[indices[0]].left = parseFloat(cursor.toFixed(2));
        for (let c = 1; c < indices.length; c++) {
          cursor += state.openingPositions[indices[c - 1]].w + gap;
          state.openingPositions[indices[c]].left = parseFloat(cursor.toFixed(2));
        }
      } else {
        // Sorteer op huidige top-positie, eerste blijft staan
        indices.sort(function (a, b) { return getEffectiveTop(a) - getEffectiveTop(b); });
        let cursor = getEffectiveTop(indices[0]);
        state.openingPositions[indices[0]].top = parseFloat(cursor.toFixed(2));
        for (let r = 1; r < indices.length; r++) {
          cursor += state.openingPositions[indices[r - 1]].h + gap;
          state.openingPositions[indices[r]].top = parseFloat(cursor.toFixed(2));
        }
      }
      renderPositionInputs();
      update();
    }

    const distributeHBtn = document.getElementById('ppb-distribute-h');
    if (distributeHBtn) distributeHBtn.addEventListener('click', function () { distributeOpenings('h'); });
    const distributeVBtn = document.getElementById('ppb-distribute-v');
    if (distributeVBtn) distributeVBtn.addEventListener('click', function () { distributeOpenings('v'); });
    const distributeGapInput = document.getElementById('ppb-distribute-gap');
    if (distributeGapInput) {
      distributeGapInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          distributeOpenings('h');
        }
      });
    }

    const deleteBtn = document.getElementById('ppb-delete-selected');
    if (deleteBtn) {
      deleteBtn.addEventListener('click', function () {
        const toDelete = Array.from(state.selectedOpenings).sort(function (a, b) { return b - a; });
        if (!toDelete.length) return;
        if (state.openings - toDelete.length < 1) return; // minstens 1 opening behouden
        saveHistory();

        // Verwijder van achteren naar voren zodat indices kloppen
        toDelete.forEach(function (idx) {
          state.openingPositions.splice(idx, 1);
        });
        // Vul terug aan tot 20 slots
        while (state.openingPositions.length < 20) {
          state.openingPositions.push({ left: null, top: null, w: state.openingW, h: state.openingH, photoDataUrl: null, photoW: null, photoH: null });
        }
        state.openings -= toDelete.length;
        state.selectedOpenings = new Set();

        syncOpeningCountButtons();

        renderPositionInputs();
        update();
      });
    }
  }

  // ----------------------------------------------------------------
  // Init
  // ----------------------------------------------------------------

  function initColorModal() {
    const openBtn  = document.getElementById('ppb-open-color-modal');
    const closeBtn = document.getElementById('ppb-close-color-modal');
    const modal    = document.getElementById('ppb-color-modal');
    if (!openBtn || !modal) return;

    openBtn.addEventListener('click', function () {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    });

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      openBtn.focus();
    }

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  // Controle-pop-up: vóór het toevoegen vragen we de klant de belangrijkste
  // punten na te lopen (glas gemeten, opening kleiner dan de print, geen
  // retour). Alleen bij een nieuw item en alleen als het ontwerp geldig is;
  // fouten en het bewerken van een bestaand item gaan direct door naar
  // addToCart, dat zelf de foutmelding toont. Eén keer per sessie: na
  // "toevoegen" in de pop-up komt hij in dit tabblad niet meer terug.
  var CHECK_SEEN_KEY = 'ppb_check_seen';

  function checkSeen() {
    try { return sessionStorage.getItem(CHECK_SEEN_KEY) === '1'; } catch (_) { return false; }
  }

  function onAddClick() {
    const modal = document.getElementById('ppb-check-modal');
    if (!modal || checkSeen() || editMode.active || validateAll().length > 0 || !findVariant()) {
      addToCart();
      return;
    }
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    document.getElementById('ppb-check-confirm').focus();
  }

  function initCheckModal() {
    const modal = document.getElementById('ppb-check-modal');
    if (!modal) return;
    const addBtn = document.getElementById('ppb-add-btn');

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    document.getElementById('ppb-check-confirm').addEventListener('click', function () {
      try { sessionStorage.setItem(CHECK_SEEN_KEY, '1'); } catch (_) { /* negeren */ }
      closeModal();
      addToCart();
    });

    function goBack() {
      closeModal();
      if (addBtn) addBtn.focus();
    }

    document.getElementById('ppb-check-back').addEventListener('click', goBack);
    modal.addEventListener('click', function (e) { if (e.target === modal) goBack(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) goBack();
    });
  }

  function initUndo() {
    const btn = document.getElementById('ppb-undo');
    if (btn) btn.addEventListener('click', undoHistory);

    document.addEventListener('keydown', function (e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'z' && !e.shiftKey) {
        const active = document.activeElement;
        const isInput = active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA');
        if (!isInput) {
          e.preventDefault();
          undoHistory();
        }
      }
    });
  }

  // ----------------------------------------------------------------
  // Kopiëren en plakken van uitsneden (⌘C / ⌘V, of de dupliceerknop)
  // ----------------------------------------------------------------

  const MAX_OPENINGS = 20;

  function copySelectedOpenings() {
    const indices = Array.from(state.selectedOpenings).sort(function (a, b) { return a - b; });
    if (!indices.length) return false;
    copiedOpenings = indices.map(function (i) {
      return Object.assign({}, state.openingPositions[i], {
        left: getEffectiveLeft(i),
        top:  getEffectiveTop(i),
      });
    });
    return true;
  }

  // Zoekt voor de gekopieerde groep de vrije plek die het dichtst bij
  // "1 cm rechtsonder het origineel" ligt. Past hij nergens, dan komt hij
  // daar toch te staan en kleurt hij rood, net als bij handmatig slepen.
  function findPastePosition(items) {
    const fmt = getActiveFormat();
    let minL = Infinity, minT = Infinity, maxR = -Infinity, maxB = -Infinity;
    items.forEach(function (it) {
      minL = Math.min(minL, it.left); minT = Math.min(minT, it.top);
      maxR = Math.max(maxR, it.left + it.w); maxB = Math.max(maxB, it.top + it.h);
    });
    const bw = maxR - minL, bh = maxB - minT;
    const maxLeft = fmt.w - bw - MIN_MARGIN, maxTop = fmt.h - bh - MIN_MARGIN;
    const wantL = Math.min(Math.max(minL + 1, MIN_MARGIN), Math.max(maxLeft, MIN_MARGIN));
    const wantT = Math.min(Math.max(minT + 1, MIN_MARGIN), Math.max(maxTop, MIN_MARGIN));

    const existing = [];
    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      existing.push({ x: getEffectiveLeft(i), y: getEffectiveTop(i), w: od.w, h: od.h });
    }

    function fits(l, t) {
      return items.every(function (it) {
        const r = { x: it.left - minL + l, y: it.top - minT + t, w: it.w, h: it.h };
        return existing.every(function (e) { return !rectsTooClose(r, e); });
      });
    }

    let best = null;
    if (maxLeft >= MIN_MARGIN && maxTop >= MIN_MARGIN) {
      for (let l = MIN_MARGIN; l <= maxLeft + 0.001; l += 0.5) {
        for (let t = MIN_MARGIN; t <= maxTop + 0.001; t += 0.5) {
          const dist = (l - wantL) * (l - wantL) + (t - wantT) * (t - wantT);
          if ((!best || dist < best.dist) && fits(l, t)) best = { l: l, t: t, dist: dist };
        }
      }
    }
    const l = best ? best.l : wantL, t = best ? best.t : wantT;
    return { dx: l - minL, dy: t - minT };
  }

  function pasteOpenings() {
    if (!copiedOpenings.length) return;
    const room = MAX_OPENINGS - state.openings;
    if (room <= 0) return;
    const items = copiedOpenings.slice(0, room);
    saveHistory();

    const off = findPastePosition(items);
    const pasted = new Set();
    items.forEach(function (it) {
      const idx = state.openings;
      state.openingPositions[idx] = Object.assign({}, it, {
        left: parseFloat((it.left + off.dx).toFixed(2)),
        top:  parseFloat((it.top  + off.dy).toFixed(2)),
      });
      state.openings += 1;
      pasted.add(idx);
    });
    state.selectedOpenings = pasted;

    // Volgende ⌘V plakt weer een stapje verder
    copiedOpenings = items.map(function (it) {
      return Object.assign({}, it, { left: it.left + off.dx, top: it.top + off.dy });
    });

    syncOpeningCountButtons();
    renderPositionInputs();
    update();
  }

  function syncOpeningCountButtons() {
    const customInput = document.getElementById('ppb-openings-custom');
    if (customInput) customInput.value = [1,2,3,4].includes(state.openings) ? '' : state.openings;
    document.querySelectorAll('.ppb-opening-btn').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    const fixedBtn = document.getElementById('ppb-openings-' + state.openings);
    if (fixedBtn) { fixedBtn.classList.add('is-active'); fixedBtn.setAttribute('aria-pressed', 'true'); }
  }

  function initClipboard() {
    const dupBtn = document.getElementById('ppb-duplicate-selected');
    if (dupBtn) dupBtn.addEventListener('click', function () {
      if (copySelectedOpenings()) pasteOpenings();
    });

    document.addEventListener('keydown', function (e) {
      if (!(e.metaKey || e.ctrlKey) || e.shiftKey || e.altKey) return;
      const key = e.key.toLowerCase();
      if (key !== 'c' && key !== 'v') return;
      const active = document.activeElement;
      if (active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA' || active.tagName === 'SELECT' || active.isContentEditable)) return;
      if (!document.getElementById('ppb-preview-svg')) return;

      if (key === 'c') {
        // Geselecteerde tekst op de pagina gaat voor
        const sel = window.getSelection && window.getSelection();
        if (sel && String(sel).length) return;
        if (copySelectedOpenings()) e.preventDefault();
      } else if (copiedOpenings.length) {
        e.preventDefault();
        pasteOpenings();
      }
    });
  }

  function initCheatsheet() {
    const openBtn  = document.getElementById('ppb-open-cheatsheet');
    const closeBtn = document.getElementById('ppb-close-cheatsheet');
    const modal    = document.getElementById('ppb-cheatsheet-modal');
    if (!openBtn || !modal) return;

    var cheatsheetTargetOpening = null; // null = gebruik selectie/alle

    function openModal(targetOpening) {
      cheatsheetTargetOpening = (targetOpening !== undefined) ? targetOpening : null;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      cheatsheetTargetOpening = null;
    }

    openBtn.addEventListener('click', function () { openModal(); });

    // Knoppen per opening (dynamisch gegenereerd, dus via delegatie)
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.ppb-cheatsheet-btn--inline');
      if (!btn) return;
      const idx = parseInt(btn.dataset.openingTarget, 10);
      openModal(idx);
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

    // "Gebruik" knoppen: vul binnenmaat in voor geselecteerde openingen (of alle als geen geselecteerd)
    modal.querySelectorAll('.ppb-cheatsheet-apply').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const w = parseFloat(btn.dataset.w);
        const h = parseFloat(btn.dataset.h);

        // Welke openingen updaten? Via inline-knop → die specifieke opening; anders geselecteerde of alle
        const targets = cheatsheetTargetOpening !== null
          ? [cheatsheetTargetOpening]
          : state.selectedOpenings.size > 0
            ? Array.from(state.selectedOpenings)
            : Array.from({ length: state.openings }, function (_, i) { return i; });

        targets.forEach(function (idx) {
          state.openingPositions[idx].w = w;
          state.openingPositions[idx].h = h;
          var wInput = document.getElementById('ppb-size-' + idx + '-w');
          var hInput = document.getElementById('ppb-size-' + idx + '-h');
          if (wInput) wInput.value = w;
          if (hInput) hInput.value = h;
        });

        update();
        closeModal();
      });
    });
  }

  function fixSiblingTitles() {
    const builder = document.getElementById('passe-partout-builder');
    if (!builder) return;

    // Vervang gewone koppeltekens in "passe-partout" door niet-afbrekend koppelteken
    document.querySelectorAll('.ppb-section-title, .ppb-section h2, .ppb-section h1').forEach(function(el) {
      el.innerHTML = el.innerHTML.replace(/passe-partout/gi, 'passe‑partout');
    });

    // Verander "Customer Reviews" / "Klantbeoordelingen" / "Kundenbewertungen" naar "Reviews"
    document.querySelectorAll('[class*="jdgm-rev-widg__title"], [class*="jdgm-widget-title"], [class*="jdgm-all-reviews__title"]').forEach(function(el) {
      if (/customer reviews|klantbeoordelingen|kundenbewertungen/i.test(el.textContent)) {
        el.textContent = 'Reviews';
      }
    });

    if (!isEN) return;
    var section = builder.closest('.shopify-section');
    if (!section) return;
    var sibling = section.nextElementSibling;
    while (sibling) {
      sibling.querySelectorAll('h2, .title').forEach(function(el) {
        if (el.textContent.trim().toLowerCase().includes('suitable list')) {
          el.textContent = el.textContent.replace(/suitable list/i, 'suitable frame');
        }
      });
      sibling = sibling.nextElementSibling;
    }
  }

  function init() {
    const root = document.getElementById('passe-partout-builder');
    if (!root) return;

    initSVGDragListeners();
    bindEvents();
    updateColorCircleTexture();
    updateColorVisibility();
    renderPositionInputs();
    update();
    initColorModal();
    initCheckModal();
    initCheatsheet();
    initUndo();
    initClipboard();
    fixSiblingTitles();
    initEditMode();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
